// Faq Section Functionlity Start
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[js-accordion]').forEach((accordion) => {

    const headers = accordion.querySelectorAll('[js-accordion-header]');

    // 👉 Agar ek se zyada items hain to first open karo
    if (headers.length > 1) {
      headers[0].classList.add('active');
      let firstPanel = headers[0].nextElementSibling;
      if (firstPanel) {
        firstPanel.classList.add('active');
      }
    }

    headers.forEach((header) => {
      header.addEventListener('click', function () {

        headers.forEach((item) => {
          if (item !== this) {
            item.classList.remove('active');
            let panel = item.nextElementSibling;
            if (panel) {
              panel.classList.remove('active');
            }
          }
        });

        this.classList.toggle('active');
        let panel = this.nextElementSibling;
        if (panel) {
          panel.classList.toggle('active');
        }

        // Closing a long answer above this one pulls the page up; bring the
        // clicked question back on screen if it slid out of view.
        if (window.BzScroll) window.BzScroll.keepInView(this);
      });
    });

  });

});
// Faq Section Functionlity End

// Pdf Popup & zoom & slider Functionlity Start

// document.addEventListener("DOMContentLoaded", function () {

//   let swipers = [];

//   const popups = document.querySelectorAll('[js-popup-modal]');

//   popups.forEach((popup, index) => {

//     const openBtn = document.querySelectorAll('.hb-open-pdf')[index];
//     const closeBtn = popup.querySelector('[hb-js-popup-close]');
//     const overlay = popup.querySelector('[hb-js-popup-overlay]');

//     let swiper = null;

//     // ===== OPEN =====
//     if (openBtn) {
//       openBtn.addEventListener('click', function(e) {
//         e.preventDefault();

//         popup.style.display = 'block';
//         document.body.style.overflow = 'hidden';

//         setTimeout(() => {
//           if (!swiper) {
//             swiper = new Swiper(popup.querySelector('[hb-js-popup-slider]'), {
//               slidesPerView: 1,
//               spaceBetween: 10,

//               navigation: {
//                 nextEl: popup.querySelector('.swiper-button-next'),
//                 prevEl: popup.querySelector('.swiper-button-prev'),
//               },

//               pagination: {
//                 el: popup.querySelector('.swiper-pagination'),
//                 clickable: true,
//               },
//             });

//             swipers[index] = swiper;

//           } else {
//             swiper.update();
//           }
//         }, 300);
//       });
//     }

//     // ===== CLOSE =====
//     function closePopup() {
//       popup.style.display = 'none';
//       document.body.style.overflow = '';
//     }

//     if (closeBtn) closeBtn.addEventListener('click', closePopup);
//     if (overlay) overlay.addEventListener('click', closePopup);

//     // ===== ZOOM =====
//     let zoomLevel = 1;
//     const zoomStep = 0.1;
//     const maxZoom = 2;
//     const minZoom = 0.5;

//     const zoomInBtn = popup.querySelector('.zoom-in');
//     const zoomOutBtn = popup.querySelector('.zoom-out');

//     function updateZoom() {
//       popup.querySelectorAll('.hb-pdf-slide iframe').forEach(el => {
//         el.style.transform = `scale(${zoomLevel})`;
//         el.style.transformOrigin = 'top left';
//       });

//       const zoomText = popup.querySelector('.hb-pdf-popup__zoom-no');
//       if (zoomText) {
//         zoomText.innerText = Math.round(zoomLevel * 100) + '%';
//       }
//     }

//     if (zoomInBtn && zoomOutBtn) {
//       zoomInBtn.addEventListener('click', () => {
//         if (zoomLevel < maxZoom) {
//           zoomLevel += zoomStep;
//           updateZoom();
//         }
//       });

//       zoomOutBtn.addEventListener('click', () => {
//         if (zoomLevel > minZoom) {
//           zoomLevel -= zoomStep;
//           updateZoom();
//         }
//       });
//     }

//   });

// });

// ===== DYNAMIC PDF & VIDEO POPUP =====
document.addEventListener('DOMContentLoaded', function () {

// ---- PDF Popup (PDF.js canvas renderer — cross-device: iOS / Android / desktop) ----
  // Single-PDF variant: one document per popup, no document-to-document carousel.
  // Renders every page to its own <canvas> in one continuous vertical scroll (like a
  // normal document viewer), but virtualized: only pages near the viewport actually
  // hold a rendered canvas. Pages that scroll far away get their canvas torn down and
  // replaced by an empty placeholder of the same size, so a 15-page report never has
  // more than a handful of canvases live at once — this is what keeps iOS Safari's
  // per-tab canvas memory budget from being blown.
  var hbPdfPopup = document.getElementById('hbDynamicPdfPopup');
  var hbPdfZoom = 1;
  var hbPdfRecord = null; // the single { slide, url, entry, loading, cancelled } in play
  var hbPdfResizeBound = false;
  var HB_PDFJS_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';
  var hbPdfJsLoadPromise = null;
  // Cap retina backing-store memory so iOS Safari's per-tab canvas budget isn't blown.
  var HB_PDF_MAX_DPR = 2;
  var HB_PDF_MAX_CANVAS_AREA = 4 * 1024 * 1024; // max device pixels per page canvas (~4M)
  // How far outside the visible area (as a fraction of the scroll container's own
  // height) a page is kept rendered before it's torn down again. Big enough that
  // scrolling doesn't visibly pop pages in, small enough that only a handful of
  // pages are ever live at once.
  var HB_PDF_RENDER_MARGIN = '75% 0px 75% 0px';

  // Lazy-load PDF.js only when a PDF is first opened; cache the promise for reuse.
  function hbEnsurePdfJs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (hbPdfJsLoadPromise) return hbPdfJsLoadPromise;
    hbPdfJsLoadPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = HB_PDFJS_CDN + 'pdf.min.js';
      s.onload = function () {
        if (window.pdfjsLib) {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = HB_PDFJS_CDN + 'pdf.worker.min.js';
          resolve(window.pdfjsLib);
        } else {
          reject(new Error('pdfjsLib not available after script load'));
        }
      };
          s.onerror = function () { reject(new Error('Failed to load PDF.js')); };
      document.head.appendChild(s);
    });
    return hbPdfJsLoadPromise;
  }

  // Start fetching the PDF.js library in the background as soon as the page has
  // at least one PDF trigger on it, instead of waiting for the click — so by the
  // time someone actually opens a report, the library is already there.
  if (document.querySelector('.hb-open-pdf[data-items]')) {
    hbEnsurePdfJs().catch(function () {});
  }

  // Fetch the PDF as an ArrayBuffer
  // as a fallback now — see hbLoadPdfDocument below.
  function hbFetchPdfBuffer(url) {
    return fetch(url, { mode: 'cors', credentials: 'omit' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.arrayBuffer();
    });
  }

  function hbLoadPdfDocument(pdfjsLib, url) {
    // Prefer PDF.js's own streaming/range-request loading: it can start
    // parsing (and rendering page 1) before the whole file has finished
    // downloading, which is what makes the popup open quickly, especially
    // on mobile networks. Only fall back to downloading the whole file up
    // front if that fails (some proxies/very old browsers block range
    // requests).
    return pdfjsLib.getDocument({ url: url }).promise.catch(function () {
      return hbFetchPdfBuffer(url).then(function (buf) {
        return pdfjsLib.getDocument({ data: buf, disableRange: true, disableStream: true }).promise;
      });
    });
  }

  // Available render width for the document's pages (the scroll host's inner width).
  // Must never return a non-positive value: if the slide hasn't been laid out yet,
  // clientWidth is 0, so fall back to the slide's own box, then a fixed default.
  function hbContainerWidth(entry) {
    var wrap = entry.pagesWrap;
    var w = wrap ? wrap.clientWidth : 0;
    if (!(w > 0)) w = entry.slide.clientWidth;
    if (!(w > 0)) w = entry.slide.getBoundingClientRect().width;
    if (!(w > 0)) w = 300;
    return w;
  }

  // Pick a devicePixelRatio that stays crisp but never exceeds iOS's per-canvas
  // memory ceiling. Caps DPR at HB_PDF_MAX_DPR, then scales it down further if the
  // resulting backing store would exceed HB_PDF_MAX_CANVAS_AREA device pixels.
  function hbComputeDpr(cssW, cssH) {
    var dpr = Math.min(window.devicePixelRatio || 1, HB_PDF_MAX_DPR);
    var area = cssW * cssH * dpr * dpr;
    if (area > HB_PDF_MAX_CANVAS_AREA && cssW > 0 && cssH > 0) {
      dpr = Math.max(1, Math.sqrt(HB_PDF_MAX_CANVAS_AREA / (cssW * cssH)));
    }
    return dpr;
  }

  // The scale a page is drawn at: fills the container's full width (never
  // letterboxed on the sides, per design), then the user's zoom multiplies on
  // top of that. Height is whatever the page's own aspect ratio makes it —
  // the slide scrolls, so a tall result is completely normal.
  function hbPageFitScale(entry, unscaledWidth) {
    var containerWidth = hbContainerWidth(entry);
    return (containerWidth / unscaledWidth) * hbPdfZoom;
  }

  // Give a page's placeholder <div> its correct box size (before or instead of
  // rendering into it), so the scrollbar/scroll position never jumps around a
  // page that hasn't been rendered yet or has been unrendered to save memory.
  function hbSizePagePlaceholder(entry, pageEntry) {
    var scale = hbPageFitScale(entry, pageEntry.unscaledWidth);
    var cssW = Math.max(1, Math.round(pageEntry.unscaledWidth * scale));
    var cssH = Math.max(1, Math.round(pageEntry.unscaledHeight * scale));
    pageEntry.wrap.style.width = cssW + 'px';
    pageEntry.wrap.style.height = cssH + 'px';
    pageEntry.cssW = cssW;
    pageEntry.cssH = cssH;
  }

  // Render one page's canvas into its (already correctly sized) placeholder.
  // Renders into an offscreen canvas and only swaps it in once fully painted
  // (no blank flash), and cancels any render this call supersedes so repeated
  // zoom/resize changes never pile up concurrent raster work.
  function hbRenderPage(entry, pageEntry) {
    if (!pageEntry.wrap.isConnected) return Promise.resolve();
    hbSizePagePlaceholder(entry, pageEntry);
    if (pageEntry.renderTask) {
      try { pageEntry.renderTask.cancel(); } catch (e) {}
      pageEntry.renderTask = null;
    }
    var myRender = (pageEntry.renderToken || 0) + 1;
    pageEntry.renderToken = myRender;
    if (!pageEntry.rendered) pageEntry.wrap.classList.add('hb-pdf-page--pending');
    return entry.pdf.getPage(pageEntry.index + 1).then(function (page) {
      if (pageEntry.renderToken !== myRender || !pageEntry.wrap.isConnected) return;
      var scale = hbPageFitScale(entry, pageEntry.unscaledWidth);
      var viewport = page.getViewport({ scale: scale });
      var dpr = hbComputeDpr(viewport.width, viewport.height);
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.width = Math.max(1, Math.floor(viewport.width * dpr));
      canvas.height = Math.max(1, Math.floor(viewport.height * dpr));
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var task = page.render({ canvasContext: ctx, viewport: viewport });
      pageEntry.renderTask = task;
      return task.promise.then(function () {
        if (pageEntry.renderTask === task) pageEntry.renderTask = null;
        if (pageEntry.renderToken !== myRender || !pageEntry.wrap.isConnected) return;
        pageEntry.wrap.innerHTML = '';
        pageEntry.wrap.appendChild(canvas);
        pageEntry.rendered = true;
        pageEntry.wrap.classList.remove('hb-pdf-page--pending');
        hbTouchRenderedPage(entry, pageEntry);
      });
    }).catch(function (err) {
      if (err && err.name === 'RenderingCancelledException') return;
      if (pageEntry.renderToken === myRender) {
        pageEntry.wrap.classList.remove('hb-pdf-page--pending');
        console.warn('hb PDF page render failed:', pageEntry.index + 1, err);
      }
    });
  }

  // Tear a rendered page's canvas back down to an empty, correctly-sized
  // placeholder — frees its memory without disturbing scroll position.
  function hbUnrenderPage(pageEntry) {
    if (pageEntry.renderTask) {
      try { pageEntry.renderTask.cancel(); } catch (e) {}
      pageEntry.renderTask = null;
    }
    if (!pageEntry.rendered) return;
    pageEntry.renderToken = (pageEntry.renderToken || 0) + 1; // discard any in-flight render
    pageEntry.wrap.innerHTML = '';
    pageEntry.wrap.classList.remove('hb-pdf-page--pending');
    pageEntry.rendered = false;
  }

  // Re-render every currently-rendered page (zoom/resize changed the scale) and
  // resize every placeholder so the ones not currently rendered stay the right
  // height too.
  function hbRelayoutEntry(entry) {
    entry.pages.forEach(function (pageEntry) {
      if (pageEntry.rendered) {
        hbRenderPage(entry, pageEntry);
      } else {
        hbSizePagePlaceholder(entry, pageEntry);
      }
    });
  }

  // Which page is most visible right now, for the "12 / 24" indicator — the page
  // whose placeholder is closest to the top of the scroll container.
  function hbUpdateVisiblePage(entry) {
    var hostTop = entry.slide.getBoundingClientRect().top;
    var best = null;
    var bestDist = Infinity;
    entry.pages.forEach(function (pageEntry) {
      var rect = pageEntry.wrap.getBoundingClientRect();
      var dist = Math.abs(rect.top - hostTop);
      if (dist < bestDist) { bestDist = dist; best = pageEntry.index; }
    });
    if (best !== null && best !== entry.currentPageIndex) {
      entry.currentPageIndex = best;
      hbUpdatePageNavUI();
    }
  }

  // Keep the most recently seen pages rendered so scrolling back to them is
  // instant, but cap the count so very long documents still can't blow up
  // memory. A page currently on screen is never evicted.
  var HB_PDF_MAX_RENDERED_PAGES = 10;

  function hbTouchRenderedPage(entry, pageEntry) {
    if (!entry.renderedOrder) entry.renderedOrder = [];
    var idx = entry.renderedOrder.indexOf(pageEntry);
    if (idx !== -1) entry.renderedOrder.splice(idx, 1);
    entry.renderedOrder.push(pageEntry);
  }

  function hbTrimRenderedPages(entry) {
    if (!entry.renderedOrder) return;
    entry.renderedOrder = entry.renderedOrder.filter(function (p) { return p.rendered; });
    while (entry.renderedOrder.length > HB_PDF_MAX_RENDERED_PAGES) {
      var oldest = entry.renderedOrder[0];
      if (oldest.visible) break; // never evict a page that's on screen right now
      entry.renderedOrder.shift();
      hbUnrenderPage(oldest);
    }
  }

  // Renders pages as they approach the visible area. Pages that leave the
  // visible area stay cached (see hbTrimRenderedPages above) instead of being
  // torn down immediately, so scrolling back and forth feels instant.
  function hbSetupPageObserver(entry) {
    if (!('IntersectionObserver' in window)) {
      // No IO support: just render everything. Rare enough (very old browsers)
      // that it's not worth a manual-scroll-tracking fallback.
      entry.pages.forEach(function (pageEntry) { hbRenderPage(entry, pageEntry); });
      return;
    }
    entry.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (obsEntry) {
        var pageEntry = obsEntry.target.__hbPageEntry;
        if (!pageEntry) return;
        pageEntry.visible = obsEntry.isIntersecting;
        if (obsEntry.isIntersecting && !pageEntry.rendered) {
          hbRenderPage(entry, pageEntry);
        }
      });
      hbUpdateVisiblePage(entry);
      hbTrimRenderedPages(entry);
    }, { root: entry.slide, rootMargin: HB_PDF_RENDER_MARGIN });
    entry.pages.forEach(function (pageEntry) { entry.observer.observe(pageEntry.wrap); });
    entry.slide.addEventListener('scroll', function () { hbUpdateVisiblePage(entry); }, { passive: true });
  }

  function hbSetupSizeObserver(entry) {
    if (!('ResizeObserver' in window)) return;
    var raf = null;
    var lastWidth = entry.slide.clientWidth;
    entry.resizeObserver = new ResizeObserver(function (entries) {
      var newWidth = (entries[0] && entries[0].contentRect) ? entries[0].contentRect.width : entry.slide.clientWidth;
      if (Math.round(newWidth) === Math.round(lastWidth)) return; // height-only change (mobile toolbar) — ignore
      lastWidth = newWidth;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        hbRelayoutEntry(entry);
      });
    });
    entry.resizeObserver.observe(entry.slide);
  }

  // Tears down the open document: disconnects both observers, frees every
  // page's canvas, empties its DOM, and — crucially — destroys the underlying
  // PDF.js document/worker. Without that last step, every open+close cycle
  // leaves a PDF.js document and its worker alive in memory forever, which is
  // what made the page (and eventually the phone) feel sluggish the longer a
  // session went on.
  function hbDestroyEntry(entry) {
    if (entry.observer) entry.observer.disconnect();
    if (entry.resizeObserver) entry.resizeObserver.disconnect();
    entry.pages.forEach(hbUnrenderPage);
    if (entry.pagesWrap) entry.pagesWrap.innerHTML = '';
    if (entry.pdf && typeof entry.pdf.destroy === 'function') {
      try { entry.pdf.destroy(); } catch (e) {}
    }
  }

  function hbLoadPdf(record) {
    if (record.entry || record.loading) return;
    record.loading = true;
    record.cancelled = false;
    var slide = record.slide;
    var loading = document.createElement('div');
    loading.className = 'hb-pdf-loading';
    loading.textContent = 'Loading PDF…';
    slide.appendChild(loading);

    hbEnsurePdfJs()
      .then(function (pdfjsLib) { return hbLoadPdfDocument(pdfjsLib, record.url); })
      .then(function (pdf) { return pdf.getPage(1).then(function (firstPage) { return { pdf: pdf, firstPage: firstPage }; }); })
      .then(function (result) {
        if (record.cancelled) return;
        if (loading.parentNode) loading.remove();
        var pdf = result.pdf;
        var unscaled1 = result.firstPage.getViewport({ scale: 1 });

        var pagesWrap = document.createElement('div');
        pagesWrap.className = 'hb-pdf-pages';
        slide.appendChild(pagesWrap);

        var entry = {
          pdf: pdf,
          slide: slide,
          pagesWrap: pagesWrap,
          numPages: pdf.numPages,
          currentPageIndex: 0,
          observer: null,
          pages: []
        };

        for (var i = 0; i < pdf.numPages; i++) {
          var wrap = document.createElement('div');
          wrap.className = 'hb-pdf-page';
          var pageEntry = {
            index: i,
            wrap: wrap,
            // Assume uniform page size (true for the vast majority of PDFs);
            // corrected for an individual page automatically if it ever renders
            // at a different native size.
            unscaledWidth: unscaled1.width,
            unscaledHeight: unscaled1.height,
            rendered: false,
            renderToken: 0
          };
          wrap.__hbPageEntry = pageEntry;
          hbSizePagePlaceholder(entry, pageEntry);
          pagesWrap.appendChild(wrap);
          entry.pages.push(pageEntry);
        }

        record.entry = entry;
        record.loading = false;
        hbSetupPageObserver(entry);
        hbSetupSizeObserver(entry);
        hbUpdatePageNavUI();
      })
      .catch(function (err) {
        record.loading = false;
        if (record.cancelled) return;
        console.error('PDF render error:', err);
        if (loading.parentNode) loading.remove();
        if (!slide.isConnected) return;
        var errDiv = document.createElement('div');
        errDiv.className = 'hb-pdf-error';
        errDiv.innerHTML = 'This preview could not be loaded in the viewer.<br>' +
          '<a class="hb-pdf-external" href="' + record.url + '" target="_blank" rel="noopener">Open the PDF in a new tab ↗</a>';
        slide.appendChild(errDiv);
      });
  }

    function openPdfPopup(title, text, urls) {
    if (!hbPdfPopup) return;
    if (!urls || !urls.length) return;
    document.getElementById('hbPdfTitle').textContent = title || '';
    document.getElementById('hbPdfText').textContent = text || '';
    var wrapper = document.getElementById('hbPdfSwiperWrapper');
    var url = urls[0];

    if (hbPdfZoomCommitTimer) { clearTimeout(hbPdfZoomCommitTimer); hbPdfZoomCommitTimer = null; }
    hbPdfZoom = 1;
    updatePdfZoomUI();

    // Single-PDF variant: only the first url is ever used. No carousel — the
    // next/prev/pagination controls (if present in the markup) simply stay
    // hidden, since there is nothing to switch between.
    ['#hbPdfNext', '#hbPdfPrev', '#hbPdfPagination'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.style.display = 'none';
    });

    if (hbPdfRecord && hbPdfRecord.url === url && hbPdfRecord.entry) {
      // Reopening the exact same report that's still loaded from last time —
      // show it instantly instead of re-downloading and re-rendering it.
      hbPdfPopup.style.display = 'block';
      document.body.style.overflow = 'hidden';
      hbEnsurePageNavUI();
      hbRelayoutEntry(hbPdfRecord.entry);
      hbUpdatePageNavUI();
    } else {
      // A different report (or nothing) was loaded — free it before starting
      // the new one.
      hbDestroyPdf();
      wrapper.innerHTML = '';
      var slide = document.createElement('div');
      slide.className = 'hb-pdf-slide swiper-slide';
      wrapper.appendChild(slide);
      hbPdfRecord = { slide: slide, url: url, entry: null, loading: false, cancelled: false };

      hbPdfPopup.style.display = 'block';
      document.body.style.overflow = 'hidden';
      hbEnsurePageNavUI();
      hbLoadPdf(hbPdfRecord);
    }

       hbBindPdfResize();
    hbBindPdfWheelZoom();
    hbBindPdfPinchZoom();
    hbBindPdfPanDrag();
  }

  function hbDestroyPdf() {
    if (hbPdfRecord) {
      hbPdfRecord.cancelled = true;
      if (hbPdfRecord.entry) hbDestroyEntry(hbPdfRecord.entry);
    }
    hbPdfRecord = null;
  }

  function closePdfPopup() {
    if (!hbPdfPopup) return;
    hbPdfPopup.style.display = 'none';
    document.body.style.overflow = '';
    // Deliberately NOT destroyed here — reopening the same report a moment
    // later (the common case) should be instant. It's freed only when a
    // different report is opened (see openPdfPopup above) or the page is
    // actually left (see pagehide below).
    hbUpdatePageNavUI();
  }

  if (document.getElementById('hbPdfClose')) {
    document.getElementById('hbPdfClose').addEventListener('click', closePdfPopup);
  }
  if (document.getElementById('hbPdfOverlay')) {
    document.getElementById('hbPdfOverlay').addEventListener('click', closePdfPopup);
  }
  // Escape closes the popup — a standard expectation for any modal viewer,
  // not just PDF readers.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && hbPdfPopup && hbPdfPopup.style.display !== 'none') {
      closePdfPopup();
    }
  });
  // Free the cached document once the person actually leaves the page —
  // keeping it cached only makes sense while they might come back to it.
  window.addEventListener('pagehide', function () { hbDestroyPdf(); });

  var HB_PDF_ZOOM_MIN = 0.5;
  var HB_PDF_ZOOM_MAX = 3;
  var HB_PDF_ZOOM_STEP = 0.1;
  var hbPdfZoomCommitTimer = null;

  // Cheap, instant visual feedback: resize each page's actual box to the new
  // zoom level (the canvas inside auto-fits it via CSS max-width), so the
  // whole column reflows correctly in real time without the expensive PDF
  // re-raster. Also flips the pan affordance the moment zoom crosses 100%
  // (there's no document-to-document swipe here to guard against, but the
  // class still lets horizontal drag pan the content instead of doing nothing).
  function hbApplyZoomPreview() {
    updatePdfZoomUI();
    var zoomed = hbPdfZoom > 1.001;
    var entry = hbPdfRecord && hbPdfRecord.entry;
    if (!entry) return;
    if (entry.slide) entry.slide.classList.toggle('hb-pdf-slide--zoomed', zoomed);
    entry.pages.forEach(function (pageEntry) {
      hbSizePagePlaceholder(entry, pageEntry);
    });
  }

  // The real, crisp PDF.js re-raster. Only runs once the zoom gesture has
  // actually settled, so a fast pinch or repeated clicks don't queue up a
  // pile of full-resolution renders.
  function hbCommitZoomRender() {
    if (hbPdfZoomCommitTimer) { clearTimeout(hbPdfZoomCommitTimer); hbPdfZoomCommitTimer = null; }
    var entry = hbPdfRecord && hbPdfRecord.entry;
    if (entry) hbRelayoutEntry(entry);
  }

  function hbScheduleZoomCommit() {
    if (hbPdfZoomCommitTimer) clearTimeout(hbPdfZoomCommitTimer);
    hbPdfZoomCommitTimer = setTimeout(function () {
      hbPdfZoomCommitTimer = null;
      hbCommitZoomRender();
    }, 160);
  }

  function setPdfZoom(next) {
    next = Math.round(Math.min(HB_PDF_ZOOM_MAX, Math.max(HB_PDF_ZOOM_MIN, next)) * 100) / 100;
    if (next === hbPdfZoom) return;
    hbPdfZoom = next;
    hbApplyZoomPreview();
    hbScheduleZoomCommit();
  }

  if (document.getElementById('hbPdfZoomIn')) {
    document.getElementById('hbPdfZoomIn').addEventListener('click', function () {
      setPdfZoom(hbPdfZoom + HB_PDF_ZOOM_STEP);
    });
  }
  if (document.getElementById('hbPdfZoomOut')) {
    document.getElementById('hbPdfZoomOut').addEventListener('click', function () {
      setPdfZoom(hbPdfZoom - HB_PDF_ZOOM_STEP);
    });
  }
  // Tap the percentage label to jump back to 100%.
  if (document.getElementById('hbPdfZoomLevel')) {
    document.getElementById('hbPdfZoomLevel').addEventListener('click', function () {
      setPdfZoom(1);
    });
  }

  function updatePdfZoomUI() {
    var levelEl = document.getElementById('hbPdfZoomLevel');
    if (levelEl) levelEl.textContent = Math.round(hbPdfZoom * 100) + '%';
    var outBtn = document.getElementById('hbPdfZoomOut');
    var inBtn = document.getElementById('hbPdfZoomIn');
    if (outBtn) outBtn.disabled = hbPdfZoom <= HB_PDF_ZOOM_MIN;
    if (inBtn) inBtn.disabled = hbPdfZoom >= HB_PDF_ZOOM_MAX;
  }

  // ---- Scroll-to-zoom: Ctrl/Cmd + wheel, the standard cross-browser gesture.
  // A trackpad pinch is reported by the browser as a wheel event with ctrlKey
  // true, so this covers pinch-to-zoom for free — no separate touch handling
  // needed. Plain wheel/scroll (no Ctrl/Cmd) is left untouched so the page
  // keeps scrolling normally.
  var hbPdfWheelBound = false;
  function hbBindPdfWheelZoom() {
    if (hbPdfWheelBound) return;
    hbPdfWheelBound = true;
    var container = document.getElementById('hbPdfSwiper');
    if (!container) return;
    container.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && !e.metaKey) return; // let normal scroll pass through untouched
      e.preventDefault();
      var delta = e.deltaY > 0 ? -HB_PDF_ZOOM_STEP : HB_PDF_ZOOM_STEP;
      hbPdfZoom = Math.round(Math.min(HB_PDF_ZOOM_MAX, Math.max(HB_PDF_ZOOM_MIN, hbPdfZoom + delta)) * 100) / 100;
      hbApplyZoomPreview();
      hbScheduleZoomCommit();
    }, { passive: false });
  }

  // ---- Pinch-to-zoom: two-finger touch gesture, the standard mobile
  // expectation. Distance between the two touch points is compared to its
  // value at gesture start; the ratio scales hbPdfZoom from there, the same
  // clamping/relayout path as the wheel-zoom above. preventDefault only fires
  // while two fingers are down, so a normal one-finger vertical scroll is
  // left completely alone.
  var hbPdfPinchBound = false;
  function hbBindPdfPinchZoom() {
    if (hbPdfPinchBound) return;
    hbPdfPinchBound = true;
    var container = document.getElementById('hbPdfSwiper');
    if (!container) return;
    var pinchStartDist = 0;
    var pinchStartZoom = 1;
    var pinchRaf = null;

    function touchDistance(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    container.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pinchStartDist = touchDistance(e.touches);
        pinchStartZoom = hbPdfZoom;
      }
    }, { passive: true });

    container.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 2 || !pinchStartDist) return;
      e.preventDefault();
      var dist = touchDistance(e.touches);
      var next = Math.round(Math.min(HB_PDF_ZOOM_MAX, Math.max(HB_PDF_ZOOM_MIN, pinchStartZoom * (dist / pinchStartDist))) * 100) / 100;
      hbPdfZoom = next;
      if (pinchRaf) return;
      pinchRaf = requestAnimationFrame(function () {
        pinchRaf = null;
        hbApplyZoomPreview();
      });
    }, { passive: false });

    ['touchend', 'touchcancel'].forEach(function (evt) {
      container.addEventListener(evt, function (e) {
        if (e.touches.length < 2 && pinchStartDist) {
          pinchStartDist = 0;
          hbCommitZoomRender();
        }
      });
    });
  }

    // ---- Desktop-only hand-tool pan: click and drag anywhere on a zoomed
  // page to move around it, the same way a mouse user expects from any
  // PDF viewer. Bound with plain 'mouse*' events, which touch input never
  // fires, so this cannot interfere with the existing touch-pinch pan on
  // mobile — that stays on its own separate code path above, untouched.
  var hbPdfPanBound = false;
  function hbBindPdfPanDrag() {
    if (hbPdfPanBound) return;
    hbPdfPanBound = true;
    var container = document.getElementById('hbPdfSwiper');
    if (!container) return;
    var dragging = false;
    var startX = 0, startY = 0, startScrollLeft = 0, startScrollTop = 0;
    var slideEl = null;

    container.addEventListener('mousedown', function (e) {
      if (hbPdfZoom <= 1.001) return; // only when actually zoomed in
      var slide = e.target.closest && e.target.closest('.hb-pdf-slide');
      if (!slide) return;
      dragging = true;
      slideEl = slide;
      startX = e.clientX;
      startY = e.clientY;
      startScrollLeft = slide.scrollLeft;
      startScrollTop = slide.scrollTop;
      slide.classList.add('hb-pdf-slide--dragging');
      e.preventDefault(); // stop native text/image drag-select while panning
    });

    document.addEventListener('mousemove', function (e) {
      if (!dragging || !slideEl) return;
      slideEl.scrollLeft = startScrollLeft - (e.clientX - startX);
      slideEl.scrollTop = startScrollTop - (e.clientY - startY);
    });

    document.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      if (slideEl) slideEl.classList.remove('hb-pdf-slide--dragging');
      slideEl = null;
    });
  }

  function hbBindPdfResize() {
    if (hbPdfResizeBound) return;
    hbPdfResizeBound = true;
    var t = null;
    window.addEventListener('resize', function () {
      if (!hbPdfPopup || hbPdfPopup.style.display === 'none') return;
      clearTimeout(t);
      t = setTimeout(function () {
        var entry = hbPdfRecord && hbPdfRecord.entry;
        if (entry) hbRelayoutEntry(entry);
      }, 250);
    });
    window.addEventListener('orientationchange', function () {
      if (!hbPdfPopup || hbPdfPopup.style.display === 'none') return;
      setTimeout(function () {
        var entry = hbPdfRecord && hbPdfRecord.entry;
        if (entry) hbRelayoutEntry(entry);
      }, 350);
    });
  }

  // ---- Page indicator + jump-to-page controls ----
  // With every page visible in one continuous scroll, "prev/next" now means
  // "scroll to the previous/next page", and the counter reflects whichever page
  // is currently nearest the top of the view (kept in sync by the
  // IntersectionObserver in hbSetupPageObserver) rather than a manually-tracked
  // "current" page.
  var hbPageNavBound = false;
  function hbEnsurePageNavUI() {
    if (hbPageNavBound) return;
    hbPageNavBound = true;
    var footer = hbPdfPopup ? hbPdfPopup.querySelector('.hb-pdf-popup__footer') : null;
    if (!footer) return;
    var group = document.createElement('div');
    group.className = 'hb-pdf-pagenav';
    group.id = 'hbPdfPageNav';
    group.innerHTML =
      '<button type="button" class="hb-pdf-pagenav__btn" id="hbPdfPagePrev" aria-label="Previous page">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"></path></svg>' +
      '</button>' +
      '<span class="hb-pdf-pagenav__count" id="hbPdfPageCount">1 / 1</span>' +
      '<button type="button" class="hb-pdf-pagenav__btn" id="hbPdfPageNext" aria-label="Next page">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"></path></svg>' +
      '</button>';
    footer.insertBefore(group, footer.firstChild);
    document.getElementById('hbPdfPagePrev').addEventListener('click', function () { hbGoToPage(-1); });
    document.getElementById('hbPdfPageNext').addEventListener('click', function () { hbGoToPage(1); });
    // Left/right arrow keys flip pages while the popup is open — a natural extra for
    // a page-flip UI, on top of the buttons.
    document.addEventListener('keydown', function (e) {
      if (!hbPdfPopup || hbPdfPopup.style.display === 'none') return;
      if (e.key === 'ArrowRight') hbGoToPage(1);
      else if (e.key === 'ArrowLeft') hbGoToPage(-1);
    });
  }

  function hbCurrentPdfEntry() {
    return hbPdfRecord ? hbPdfRecord.entry : null;
  }

  function hbGoToPage(delta) {
    var entry = hbCurrentPdfEntry();
    if (!entry || !entry.numPages) return;
    var next = entry.currentPageIndex + delta;
    if (next < 0 || next >= entry.numPages) return;
    var pageEntry = entry.pages[next];
    if (pageEntry && pageEntry.wrap) {
      pageEntry.wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    entry.currentPageIndex = next;
    hbUpdatePageNavUI();
  }

  function hbUpdatePageNavUI() {
    var group = document.getElementById('hbPdfPageNav');
    if (!group) return;
    var entry = hbCurrentPdfEntry();
    var countEl = document.getElementById('hbPdfPageCount');
    var prevBtn = document.getElementById('hbPdfPagePrev');
    var nextBtn = document.getElementById('hbPdfPageNext');
    if (!entry || !entry.numPages || entry.numPages <= 1) {
      group.style.visibility = 'hidden';
      return;
    }
    group.style.visibility = 'visible';
    if (countEl) countEl.textContent = (entry.currentPageIndex + 1) + ' / ' + entry.numPages;
    if (prevBtn) prevBtn.disabled = entry.currentPageIndex <= 0;
    if (nextBtn) nextBtn.disabled = entry.currentPageIndex >= entry.numPages - 1;
  }













  var hbVideoPopup = document.getElementById('hbDynamicVideoPopup');
  var hbVideoSwiper = null;

  function openVideoPopup(title, urls) {
    if (!hbVideoPopup) return;
    document.getElementById('hbVideoTitle').textContent = title || '';
    var wrapper = document.getElementById('hbVideoSwiperWrapper');
    wrapper.innerHTML = '';
    urls.forEach(function (url) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      var fullUrl = url.startsWith('//') ? 'https:' + url : url;
      slide.innerHTML = '<video src="' + fullUrl + '" controls playsinline style="width:100%;height:400px;display:block;"></video>';
      wrapper.appendChild(slide);
    });
    hbVideoPopup.style.display = 'block';
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      if (hbVideoSwiper) { hbVideoSwiper.destroy(true, true); }
      hbVideoSwiper = new Swiper('#hbVideoSwiper', {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: '#hbVideoNext', prevEl: '#hbVideoPrev' },
        pagination: { el: '#hbVideoPagination', clickable: true },
      });
    }, 100);
  }

  function closeVideoPopup() {
    if (!hbVideoPopup) return;
    hbVideoPopup.querySelectorAll('video').forEach(function (v) { v.pause(); });
    hbVideoPopup.style.display = 'none';
    document.body.style.overflow = '';
    if (hbVideoSwiper) { hbVideoSwiper.destroy(true, true); hbVideoSwiper = null; }
  }

     if (document.getElementById('hbVideoClose')) {
      document.getElementById('hbVideoClose').addEventListener('click', closeVideoPopup);
    }
    if (document.getElementById('hbVideoOverlay')) {
      document.getElementById('hbVideoOverlay').addEventListener('click', closeVideoPopup);
    }

    var hbHtmlReportPopup = document.getElementById('hbDynamicHtmlReportPopup');

    function openHtmlReportPopup(title, url) {
      if (!hbHtmlReportPopup) return;
      document.getElementById('hbHtmlReportTitle').textContent = title || '';
      var frame = document.getElementById('hbHtmlReportFrame');
      frame.src = url;
      hbHtmlReportPopup.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }

    function closeHtmlReportPopup() {
      if (!hbHtmlReportPopup) return;
      hbHtmlReportPopup.style.display = 'none';
      document.body.style.overflow = '';
      var frame = document.getElementById('hbHtmlReportFrame');
      if (frame) frame.src = '';
    }

    if (document.getElementById('hbHtmlReportClose')) {
      document.getElementById('hbHtmlReportClose').addEventListener('click', closeHtmlReportPopup);
    }
    if (document.getElementById('hbHtmlReportOverlay')) {
      document.getElementById('hbHtmlReportOverlay').addEventListener('click', closeHtmlReportPopup);
    }

  // ---- Event Delegation — PDF & Video buttons ----
  document.addEventListener('click', function (e) {
    var pdfBtn = e.target.closest('.hb-open-pdf[data-items]');
    if (pdfBtn) {
      e.preventDefault();
      var title = pdfBtn.getAttribute('data-title') || '';
      var text = pdfBtn.getAttribute('data-text') || '';
      var urls = [];
      try { urls = JSON.parse(pdfBtn.getAttribute('data-items') || '[]'); } catch(err) {}
      if (urls.length > 0) openPdfPopup(title, text, urls);
      return;
    }
   
    
            var videoBtn = e.target.closest('.hb-open-video');
      if (videoBtn) {
        e.preventDefault();
        var vtitle = videoBtn.getAttribute('data-title') || '';
        var vurls = [];
        var hiddenVideos = videoBtn.previousElementSibling;
        if (hiddenVideos && hiddenVideos.classList.contains('hb-hidden-videos')) {
          hiddenVideos.querySelectorAll('source').forEach(function(source) {
            if (source.src && source.type === 'video/mp4') {
              vurls.push(source.src);
            }
          });
        }
        if (vurls.length > 0) openVideoPopup(vtitle, vurls);
        return;
      }
      var htmlReportBtn = e.target.closest('.hb-open-html-report');
      if (htmlReportBtn) {
        e.preventDefault();
        var rtitle = htmlReportBtn.getAttribute('data-title') || '';
        var rurl = htmlReportBtn.getAttribute('data-url') || '';
        if (rurl) openHtmlReportPopup(rtitle, rurl);
        return;
      }

    });

  // ---- Sample-report card thumbnails: render the PDF's actual first page ----
  // Reuses the same PDF.js pipeline as the popup (hbEnsurePdfJs/hbFetchPdfBuffer,
  // already defined above in this closure). Lazy via IntersectionObserver so a
  // page with many sample cards doesn't fetch every PDF up front.
  var hbPdfThumbSources = new WeakMap(); // thumb container -> pdf url
  var hbPdfThumbObserver = null;

  function hbRenderPdfThumb(container, url) {
    if (!container || container.getAttribute('data-hb-pdf-thumb-done')) return;
    container.setAttribute('data-hb-pdf-thumb-done', '1');
    container.classList.add('hb-thumb-loading');
    hbEnsurePdfJs()
      .then(function (pdfjsLib) { return hbLoadPdfDocument(pdfjsLib, url); })
      .then(function (pdf) { return pdf.getPage(1); })
      .then(function (page) {
        if (!container.isConnected) return;
        var cw = container.clientWidth || 240;
        var ch = container.clientHeight || 0;
        var unscaled = page.getViewport({ scale: 1 });
        var scale = cw / unscaled.width;
        var dpr = hbComputeDpr(unscaled.width * scale, (ch || unscaled.height * scale));
        var viewport = page.getViewport({ scale: scale * dpr });
        var canvas = document.createElement('canvas');
        canvas.setAttribute('data-hb-pdf-thumb', '1');
        canvas.width = Math.max(1, Math.floor(viewport.width));
        canvas.height = Math.max(1, Math.floor(viewport.height));
        var ctx = canvas.getContext('2d');
        return page.render({ canvasContext: ctx, viewport: viewport }).promise.then(function () {
          // A merchant-set image (metafield) stays authoritative if present —
          // only swap in the generated thumb when there's a placeholder or
          // nothing at all.
                    var existingImg = container.querySelector('img');
          if (existingImg) existingImg.remove();
          var placeholder = container.querySelector('.hb-sample-card__thumb-placeholder');
          if (placeholder) placeholder.remove();
          container.appendChild(canvas);
          container.classList.remove('hb-thumb-loading');

  // Auto-scroll preview: pan the full first page top to bottom, pause
          // at each end, then loop — it never scrolls backward, the return to
          // the top is an instant, invisible snap while faded out (handled in
          // CSS). Measured a frame later, once layout has settled on the
          // freshly appended canvas, so the box's real height is used instead
          // of a stale or zero reading. Only runs when the page is actually
          // taller than the box, and skipped entirely under reduced motion.
          var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!prefersReducedMotion) {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                if (!container.isConnected) return;
                var boxWidth = container.clientWidth;
                var boxHeight = container.clientHeight;
                if (!boxWidth || !boxHeight) return;
                var displayedHeight = boxWidth * (canvas.height / canvas.width);
                var scrollDistance = displayedHeight - boxHeight;
                if (scrollDistance > 4) {
                  container.style.setProperty('--hb-thumb-scroll', Math.round(scrollDistance) + 'px');
                  container.classList.add('hb-thumb-scrollable');
                }
              });
            });
          }
        });
        
      })
      .catch(function (err) {
        container.removeAttribute('data-hb-pdf-thumb-done'); // allow a retry later
        container.classList.remove('hb-thumb-loading');
        console.warn('hb PDF thumbnail render failed:', url, err);
      });
  }

  function hbInitPdfThumbs() {
    var cards = document.querySelectorAll('.hb-open-pdf[data-items]');
    if (!cards.length) return;

    var canObserve = 'IntersectionObserver' in window;
    if (canObserve && !hbPdfThumbObserver) {
      hbPdfThumbObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          hbPdfThumbObserver.unobserve(entry.target);
          var url = hbPdfThumbSources.get(entry.target);
          if (url) hbRenderPdfThumb(entry.target, url);
        });
      }, { rootMargin: '200px' });
    }

    cards.forEach(function (card) {
      var thumb = card.querySelector('.hb-sample-card__thumb');
      if (!thumb) return;
      // A real merchant-uploaded image already sitting there (not a placeholder
      // span) is kept as-is — the generated thumbnail only fills the gap.
      var img = thumb.querySelector('img');
      if (img && !thumb.querySelector('.hb-sample-card__thumb-placeholder')) return;

      var items = [];
      try { items = JSON.parse(card.getAttribute('data-items') || '[]'); } catch (e) {}
      var firstUrl = items[0];
      if (!firstUrl) return;

      if (canObserve) {
        hbPdfThumbSources.set(thumb, firstUrl);
        hbPdfThumbObserver.observe(thumb);
      } else {
        hbRenderPdfThumb(thumb, firstUrl);
      }
    });
  }

 // video (no extra merchant upload needed) as a silent, short (few-second)
  // loop — a "GIF-like" preview. Lazy via IntersectionObserver: nothing
  // loads or plays until the card scrolls into view, and playback pauses
  // the moment it scrolls back out. Click still opens the full popup with
  // the original HD source via the existing .hb-open-video handler above —
  // untouched. Built entirely in JS (reads the URL straight from the
  // already-rendered .hb-hidden-videos <source>, the same element the
  // click-to-open-popup handler already reads) rather than through Liquid,
  // because product.metafields...videos resolves in Liquid as a plain
  // file reference, not a full "video" Drop — so a direct .sources lookup
  // in Liquid silently returns nothing on this store. Shows the same
  // shimmer loading state as the PDF thumbnail (.hb-thumb-loading) while
  // the preview is buffering.
  var HB_VIDEO_PREVIEW_SECONDS = 3;
  var hbVideoPreviewObserver = null;

  function hbActivateVideoPreview(video) {
    if (!video.getAttribute('data-hb-preview-started')) {
      video.setAttribute('data-hb-preview-started', '1');
      var thumb = video.closest('.hb-sample-card__thumb');
      if (thumb) thumb.classList.add('hb-thumb-loading');
      video.addEventListener('loadeddata', function onLoaded() {
        if (thumb) thumb.classList.remove('hb-thumb-loading');
        video.removeEventListener('loadeddata', onLoaded);
      });
      video.addEventListener('error', function onError() {
        if (thumb) thumb.classList.remove('hb-thumb-loading');
      }, { once: true });
      video.src = video.getAttribute('data-preview-src');
    }
    video.play().catch(function () {}); // autoplay can be silently blocked; the poster stays visible either way
  }

  function hbInitVideoPreviews() {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return; // respect the OS-level motion setting: static poster only

    var cards = document.querySelectorAll('.hb-open-video');
    if (!cards.length) return;

    var canObserve = 'IntersectionObserver' in window;
    if (canObserve) {
      hbVideoPreviewObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            hbActivateVideoPreview(entry.target);
          } else {
            entry.target.pause();
          }
        });
      }, { rootMargin: '100px' });
    }

    cards.forEach(function (card) {
      var thumb = card.querySelector('.hb-sample-card__thumb');
      var hidden = card.previousElementSibling;
      if (!thumb || !hidden || !hidden.classList.contains('hb-hidden-videos')) return;
      var source = hidden.querySelector('source[type="video/mp4"]');
      if (!source || !source.src) return;

      var video = document.createElement('video');
      video.className = 'hb-sample-card__preview-video';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'none';
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('data-preview-src', source.src);
      thumb.appendChild(video);

      video.addEventListener('timeupdate', function () {
        if (video.currentTime >= HB_VIDEO_PREVIEW_SECONDS) video.currentTime = 0;
      });

      if (canObserve) {
        hbVideoPreviewObserver.observe(video);
      } else {
        hbActivateVideoPreview(video);
      }
    });
  }

  hbInitPdfThumbs();
  hbInitVideoPreviews();

});

// ===== DYNAMIC PDF & VIDEO POPUP END =====

// Example Modal — field.type se direct ID match
document.addEventListener('click', function(e) {
  var exampleBtn = e.target.closest('.hb-open-example[data-modal-id]');
  if (exampleBtn) {
    e.preventDefault();
    var modal = document.getElementById(exampleBtn.getAttribute('data-modal-id'));
    if (modal) { modal.style.display = 'block'; document.body.style.overflow = 'hidden'; }
    return;
  }
  var closeBtn = e.target.closest('[hb-js-popup-close]');
  if (closeBtn) {
    var modal = closeBtn.closest('[js-popup-modal]');
    if (modal) { modal.style.display = 'none'; document.body.style.overflow = ''; }
    return;
  }
  var overlay = e.target.closest('[hb-js-popup-overlay]');
  if (overlay) {
    var modal = overlay.closest('[js-popup-modal]');
    if (modal) { modal.style.display = 'none'; document.body.style.overflow = ''; }
    return;
  }


  
});

// slider for hb-audit__customization in hb-audit-form.liquid section Start
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.hb-audit-swiper-container', {
    slidesPerView: 1.2,
    spaceBetween: 10,
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: '.hb-audit__customization--swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        pagination: false, // desktop pe hide
      }
    }
  });
});
  // slider for hb-audit__customization in hb-audit-form.liquid section End

// ===== HB AUDIT FORM: Quantity, Block Duplication, Add to Cart, Swiper Cards =====
document.addEventListener('DOMContentLoaded', function () {
  const productForm = document.querySelector('.hb-product-form');
  if (!productForm) return;

  // Only treat audit UI as present when it lives inside this product form (skip URL checks otherwise)
  const auditContainer =
    productForm.querySelector('#hb-audit-container') ||
    productForm.querySelector('.hb-audit-container');
  const quantityInput = productForm.querySelector('.quantity__input');
  const addUrlBtn = document.getElementById('hb-add-url');
  const priceEl = productForm.querySelector('.hb-product-form__price');
  const auditWrapper = productForm.querySelector('.hb-audit');
  const subRoot = productForm.querySelector('.hb-audit-form-subscription');
  const mainProductPrice = auditWrapper ? Number(auditWrapper.dataset.mainProductPrice) : 0; 

  // ---- Max quantity cap (from metafield via data-quantity-limit) ----
  const qtySelector = document.querySelector('.hb-order-summary__qty-selector');
  const MAX_QTY = qtySelector ? (parseInt(qtySelector.dataset.quantityLimit) || 10) : 10;

  // ---- Get the template from the first .hb-audit__block ----
  const firstBlock = auditContainer ? auditContainer.querySelector('.hb-audit__block') : null;
  let blockTemplate = null;
  // Extract base title prefix from metafield (e.g. "Review #" or "Audit #")
  const firstTitle = firstBlock ? firstBlock.querySelector('.hb-audit-form__header-title') : null;
  const blockTitlePrefix = firstTitle ? firstTitle.textContent.replace(/\d+$/, '') : 'Audit #';
  // Extract the label word (e.g. "audit" or "review") from prefix for use in properties
  const blockLabel = blockTitlePrefix.replace(/[^a-zA-Z]/g, '').toLowerCase() || 'audit';

   // Two URLs count as "the same page" for this check regardless of
  // http/https, a trailing slash, or a "www." prefix — so
  // "example.com/pricing" and "https://www.example.com/pricing/" are
  // caught as duplicates too, not just an exact character match.
  function hbNormalizeUrlForCompare(value) {
    var v = String(value || '').trim().toLowerCase();
    if (!v) return '';
    v = v.replace(/^https?:\/\//, '');
    v = v.replace(/^www\./, '');
    v = v.replace(/\/+$/, '');
    return v;
  }

   // Clears the visible inline error we add below (not just the native
  // browser tooltip, which can be missed, scrolled out of view, or
  // clipped by a parent's overflow — see hbShowUrlFieldError).
  function hbClearUrlFieldError(field) {
    field.classList.remove('hb-audit__field--invalid');
    field.style.borderColor = '';
    var wrap = field.closest('.hb-audit__field') || field.parentElement;
    var err = wrap ? wrap.querySelector('.hb-audit__field-error') : null;
    if (err) err.remove();
  }

  // A persistent, always-visible error message placed right under the
  // field itself, so the person always sees WHY submission was blocked —
  // unlike the native validation bubble alone, whose visibility can
  // depend on scroll position, layout, or browser quirks.
  function hbShowUrlFieldError(field, message) {
    field.classList.add('hb-audit__field--invalid');
    field.style.borderColor = '#e5484d';
    var wrap = field.closest('.hb-audit__field') || field.parentElement;
    if (!wrap) return;
    var err = wrap.querySelector('.hb-audit__field-error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'hb-audit__field-error';
      err.setAttribute('role', 'alert');
      err.style.color = '#e5484d';
      err.style.fontSize = '13px';
      err.style.marginTop = '6px';
      err.style.fontWeight = '500';
      wrap.appendChild(err);
    }
    err.textContent = message;
    field.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function validateAuditBlockUrlFields() {/* BZ 2026-11-01: fields marked data-bz-required (custom.audit_required_fields) must be filled. */if(auditContainer){var bzRq=auditContainer.querySelectorAll('.hb-audit__block [data-bz-required]');for(var bzI=0;bzI<bzRq.length;bzI++){hbClearUrlFieldError(bzRq[bzI]);if(!String(bzRq[bzI].value||'').trim()){hbShowUrlFieldError(bzRq[bzI],'Please fill in this field.');return false;}}}
    if (!auditContainer) return true;
    const urlFields = subRoot
      ? auditContainer.querySelectorAll('.hb-audit__block input[type="url"]')
      : auditContainer.querySelectorAll('input[type="url"][required]');
    let invalid = false;
    const seenUrls = new Set();
    urlFields.forEach(function (field) { hbClearUrlFieldError(field); });
    for (let i = 0; i < urlFields.length; i++) {
      const field = urlFields[i];
      if (subRoot) field.setAttribute('required', '');
      field.setCustomValidity('');
      if (!field.value || !String(field.value).trim()) {
        field.reportValidity();
        hbShowUrlFieldError(field, 'Please enter a URL.');
        invalid = true;
        break;
      }
      if (!field.checkValidity()) {
        field.reportValidity();
        hbShowUrlFieldError(field, field.validationMessage || 'Enter a full website address, like example.com.');
        invalid = true;
        break;
      }
      const normalized = hbNormalizeUrlForCompare(field.value);
      if (normalized && seenUrls.has(normalized)) {
        field.setCustomValidity('This page was already entered above — enter a different page to audit.');
        field.reportValidity();
        hbShowUrlFieldError(field, 'This page was already entered above — enter a different page to audit.');
        invalid = true;
        break;
      }
      if (normalized) seenUrls.add(normalized);
    }
    if (auditContainer && !auditContainer.dataset.hbUrlErrorClearBound) {
      auditContainer.dataset.hbUrlErrorClearBound = '1';
      auditContainer.addEventListener('input', function (e) {
        if (e.target.matches && e.target.matches('input[type="url"]')) {
          hbClearUrlFieldError(e.target);
        }
      });
    }
    return !invalid;
  }

function hbCollectUrlsFromProperties(properties) {
  var out = [];
  if (!properties) return out;
  Object.keys(properties).forEach(function (key) {
    if (/^URL(\s|$)/i.test(String(key).trim())) {
      var normalized = hbNormalizeUrlForCompare(properties[key]);
      if (normalized) out.push(normalized);
    }
  });
  return out;
}

function hbFetchCartUrlSet() {
  return fetch(window.Shopify.routes.root + 'cart.js', {
    headers: { 'Accept': 'application/json' }
  })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      var set = new Set();
      (cart && cart.items ? cart.items : []).forEach(function (item) {
        hbCollectUrlsFromProperties(item.properties).forEach(function (u) { set.add(u); });
      });
      return set;
    })
    .catch(function (err) {
      console.error('hb cart fetch error:', err);
      return new Set();
    });
}

function hbGetFormUrlFields() {
  if (!auditContainer) return [];
  return Array.from(
    subRoot
      ? auditContainer.querySelectorAll('.hb-audit__block input[type="url"]')
      : auditContainer.querySelectorAll('input[type="url"][required]')
  );
}

function hbValidateNoCartDuplicates() {
  var fields = hbGetFormUrlFields();
  if (!fields.length) return Promise.resolve(true);
  return hbFetchCartUrlSet().then(function (cartUrls) {
    if (!cartUrls.size) return true;
    var blocked = false;
    fields.forEach(function (field) {
      if (blocked) return;
      var normalized = hbNormalizeUrlForCompare(field.value);
      if (normalized && cartUrls.has(normalized)) {
        var msg = 'This page is already in your cart for this service — enter a different page, or remove it from your cart first.';
        field.setCustomValidity(msg);
        field.reportValidity();
        hbShowUrlFieldError(field, msg);
        blocked = true;
      }
    });
    return !blocked;
  });
}


  if (firstBlock) {
    blockTemplate = firstBlock.cloneNode(true);
    // Clear all input/select/textarea values in template
    blockTemplate.querySelectorAll('input:not([type="checkbox"]):not([type="radio"])').forEach(el => { el.value = ''; });
    blockTemplate.querySelectorAll('select').forEach(el => { el.selectedIndex = 0; });
    blockTemplate.querySelectorAll('textarea').forEach(el => { el.value = ''; });
    blockTemplate.querySelectorAll('.hb-audit__field.is-other-active').forEach(el => { el.classList.remove('is-other-active'); });
    blockTemplate.querySelectorAll('input.hb-audit__multi-checkbox').forEach((el) => { el.checked = false; });
  }

  function isOtherOption(val) {
    return String(val || '').trim().toLowerCase() === 'other';
  }

  function propKeyFromName(name) {
    const raw = (name == null ? '' : String(name)).trim();
    if (!raw) return null;
    if (raw.toLowerCase().indexOf('properties[') === 0) {
      return raw.replace(/^properties\[/i, '').replace(/\]$/, '');
    }
    const m = raw.match(/properties\[(.*)\]$/i);
    return m && m[1] ? m[1].trim() : null;
  }

  function getSelectDisplayValue(select) {
    if (!select || !select.options.length || select.selectedIndex < 0) return '';
    const opt = select.options[select.selectedIndex];
    if (opt.disabled && select.selectedIndex === 0) return '';
    return String(opt.value || opt.textContent || '').trim();
  }

  function syncOtherFieldUI(select) {
    if (!select || select.tagName !== 'SELECT') return;
    const fieldEl = select.closest('.hb-audit__field');
    if (!fieldEl) return;
    const otherInput = fieldEl.querySelector('[js-other-field]');
    if (!otherInput) return;
    const displayVal = getSelectDisplayValue(select);
    if (isOtherOption(displayVal)) {
      fieldEl.classList.add('is-other-active');
    } else {
      fieldEl.classList.remove('is-other-active');
      otherInput.value = '';
      otherInput.setCustomValidity('');
    }
  }

  function initAuditOtherFields() {
    if (!auditContainer) return;
    auditContainer.querySelectorAll('.hb-audit__field select').forEach(syncOtherFieldUI);
  }

  function validateAuditOtherFields() {
    if (!auditContainer) return true;
    auditContainer.querySelectorAll('[js-other-field]').forEach(function (el) {
      el.setCustomValidity('');
    });
    const selects = auditContainer.querySelectorAll('.hb-audit__field select');
    for (let i = 0; i < selects.length; i++) {
      const select = selects[i];
      const fieldEl = select.closest('.hb-audit__field');
      const otherInput = fieldEl ? fieldEl.querySelector('[js-other-field]') : null;
      if (!otherInput) continue;
      const displayVal = getSelectDisplayValue(select);
      if (isOtherOption(displayVal)) {
        if (!otherInput.value.trim()) {
          otherInput.setCustomValidity('Please enter a value.');
          otherInput.reportValidity();
          return false;
        }
      }
      otherInput.setCustomValidity('');
    }
    return true;
  }

  function collectBlockProperties(block) {
    const properties = {};
    block.querySelectorAll('.hb-audit__field').forEach(fieldEl => {
      const urlInput = fieldEl.querySelector('input[type="url"]');
      if (urlInput && urlInput.name) {
        const v = urlInput.value.trim();
        if (v) {
          const k = propKeyFromName(urlInput.name);
          if (k) properties[k] = v;
        }
        return;
      }
      const textarea = fieldEl.querySelector('textarea');
      if (textarea && textarea.name) {
        const v = textarea.value.trim();
        if (v) {
          const k = propKeyFromName(textarea.name);
          if (k) properties[k] = v;
        }
        return;
      }
      const multiCheck = fieldEl.querySelector('input.hb-audit__multi-checkbox');
      if (multiCheck) {
        const propHost = fieldEl.querySelector('[data-hb-property]');
        const dataProp = (fieldEl.getAttribute('data-hb-property')
          || (propHost && propHost.getAttribute('data-hb-property')) || '')
          .trim();
        let k = dataProp ? propKeyFromName(dataProp) : null;
        if (!k) {
          const labelSpan = fieldEl.querySelector('.hb-audit__label-flex__row > span');
          const labelText = (labelSpan && labelSpan.textContent) ? String(labelSpan.textContent).trim() : '';
          if (labelText) k = labelText + ' 1';
        }
        if (k) {
          const vals = Array.from(fieldEl.querySelectorAll('input.hb-audit__multi-checkbox'))
            .filter((c) => c.checked)
            .map((c) => {
              const v = String(c.value != null ? c.value : '').trim();
              if (v) return v;
              if (c.labels && c.labels[0]) {
                return String(c.labels[0].textContent || '').trim();
              }
              if (c.nextElementSibling && c.nextElementSibling.tagName === 'LABEL') {
                return String(c.nextElementSibling.textContent || '').trim();
              }
              return '';
            })
            .filter(Boolean);
          if (vals.length) properties[k] = vals.join(', ');
        }
        return;
      }
      const soloNamedCheckbox = fieldEl.querySelector('input[type="checkbox"][name^="properties"]');
      if (soloNamedCheckbox && soloNamedCheckbox.name) {
        const k = propKeyFromName(soloNamedCheckbox.name);
        if (k && soloNamedCheckbox.checked) {
          properties[k] = (soloNamedCheckbox.value && String(soloNamedCheckbox.value).trim()) || 'Yes';
        }
        return;
      }
      const select = fieldEl.querySelector('select');
      const otherInput = fieldEl.querySelector('[js-other-field]');
      if (select && select.name) {
        if (select.selectedIndex === 0 && select.options[0] && select.options[0].disabled) return;
        const k = propKeyFromName(select.name);
        if (!k) return;
        const displayVal = getSelectDisplayValue(select);
        if (isOtherOption(displayVal)) {
          if (otherInput) {
            const custom = (otherInput.value || '').trim();
            if (custom) properties[k] = custom;
          } else {
            properties[k] = 'Other';
          }
        } else if (displayVal) {
          properties[k] = displayVal;
        }
        return;
      }
      const plainText = fieldEl.querySelector('input[type="text"]:not([js-other-field])');
      if (plainText && plainText.name) {
        const v = plainText.value.trim();
        if (v) {
          const key = propKeyFromName(plainText.name);
          if (key) properties[key] = v;
        }
      }
    });
    return properties;
  }

  // ---- Sync blocks to quantity ----
  function getQuantity() {
    let val = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    if (val > MAX_QTY) val = MAX_QTY;
    if (val < 1) val = 1;
    return val;
  }

  function syncBlocks(qty) {
    if (qty > MAX_QTY) qty = MAX_QTY;
    if (qty < 1) qty = 1;
    if (quantityInput && parseInt(quantityInput.value) !== qty) {
      quantityInput.value = qty;
    }
    if (!auditContainer || !blockTemplate) return;
    const currentBlocks = auditContainer.querySelectorAll('.hb-audit__block');
    const currentCount = currentBlocks.length;

    if (qty > currentCount) {
      for (let i = currentCount; i < qty; i++) {
        const newBlock = blockTemplate.cloneNode(true);
        const idx = i + 1;
        // Update title
        const title = newBlock.querySelector('.hb-audit-form__header-title');
        if (title) title.textContent = blockTitlePrefix + idx;
        // Update name attributes with correct index
        newBlock.querySelectorAll('input, select, textarea').forEach(el => {
          if (el.name) {
            el.name = el.name.replace(/\d+\]$/, idx + ']');
          }
        });
        newBlock.querySelectorAll('input.hb-audit__multi-checkbox').forEach((el) => { el.checked = false; });
        // Re-init accordion for new block
        const accHeader = newBlock.querySelector('[js-accordion-header]');
        if (accHeader) {
          accHeader.classList.remove('active');
          const panel = accHeader.nextElementSibling;
          if (panel) panel.classList.remove('active');
          accHeader.addEventListener('click', function () {
            this.classList.toggle('active');
            const p = this.nextElementSibling;
            if (p) p.classList.toggle('active');
          });
        }
        // Insert before the add-url button
        const addBtn = auditContainer.querySelector('#hb-add-url');
        auditContainer.insertBefore(newBlock, addBtn);
      }
    } else if (qty < currentCount) {
      const blocks = auditContainer.querySelectorAll('.hb-audit__block');
      for (let i = currentCount - 1; i >= qty; i--) {
        blocks[i].remove();
      }
    }

    // Update all block titles and name indices
    auditContainer.querySelectorAll('.hb-audit__block').forEach((block, i) => {
      const idx = i + 1;
      const title = block.querySelector('.hb-audit-form__header-title');
      if (title) title.textContent = blockTitlePrefix + idx;
      block.querySelectorAll('input, select, textarea').forEach(el => {
        if (el.name) {
          el.name = el.name.replace(/\d+\]$/, idx + ']');
        }
      });
      block.querySelectorAll('input.hb-audit__multi-checkbox').forEach((el) => {
        const oldId = el.getAttribute('id');
        if (!oldId) return;
        const newId = oldId.replace(/-b\d+$/g, '') + '-b' + idx;
        el.setAttribute('id', newId);
        const label = block.querySelector('label[for="' + oldId + '"]');
        if (label) label.setAttribute('for', newId);
      });
    });

    // Update swiper card audit counts & checkboxes
    updateSwiperAuditOptions(qty);
    // Update total price
    updateTotalPrice();

    // Disable/enable plus button at quantity limit
    const plusBtn = productForm.querySelector('.hb-qty__btn[name="plus"]');
    const minusBtn = productForm.querySelector('.hb-qty__btn[name="minus"]');
    if (plusBtn) plusBtn.disabled = (qty >= MAX_QTY);
    if (minusBtn) minusBtn.disabled = (qty <= 1);

    // Show/hide remove buttons on audit cards
    const allRemoveBtns = auditContainer ? auditContainer.querySelectorAll('.hb-audit-form__header__remove-btn') : [];
    allRemoveBtns.forEach(btn => {
      btn.style.display = (qty <= 1) ? 'none' : '';
    });

    initAuditOtherFields();
  }

  // ---- Audit "Other" field: delegated change/input (duplicated blocks) ----
  if (auditContainer) {
    auditContainer.addEventListener('change', function (e) {
      const t = e.target;
      if (t.tagName === 'SELECT' && t.closest('.hb-audit__field')) {
        syncOtherFieldUI(t);
      }
    });
    auditContainer.addEventListener('input', function (e) {
      if (e.target.matches('[js-other-field]')) {
        e.target.setCustomValidity('');
      }
    });
  }

  // ---- Remove block button handler (event delegation) ----
  if (auditContainer) {
    auditContainer.addEventListener('click', function (e) {
      const removeBtn = e.target.closest('.hb-audit-form__header__remove-btn');
      if (!removeBtn) return;
      const blocks = auditContainer.querySelectorAll('.hb-audit__block');
      if (blocks.length <= 1) return; // don't remove last block
      const block = removeBtn.closest('.hb-audit__block');
      if (block) {
        block.remove();
        const newQty = auditContainer.querySelectorAll('.hb-audit__block').length;
        if (quantityInput) quantityInput.value = newQty;
        syncBlocks(newQty);
      }
    });
  }

  // ---- Quantity input change ----
  if (quantityInput) {
    const observer = new MutationObserver(() => syncBlocks(getQuantity()));
    observer.observe(quantityInput, { attributes: true, attributeFilter: ['value'] });

    quantityInput.addEventListener('change', () => syncBlocks(getQuantity()));
    quantityInput.addEventListener('input', () => syncBlocks(getQuantity()));

    // Also intercept the Dawn quantity buttons
    const qtyWrapper = quantityInput.closest('quantity-input');
    if (qtyWrapper) {
      qtyWrapper.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
          setTimeout(() => syncBlocks(getQuantity()), 50);
        });
      });
    }
  }

  // ---- Initial UI state: hide remove buttons & set plus button state ----
  (function setInitialQtyState() {
    const qty = getQuantity();
    const plusBtn = productForm.querySelector('.hb-qty__btn[name="plus"]');
    const minusBtn = productForm.querySelector('.hb-qty__btn[name="minus"]');
    if (plusBtn) plusBtn.disabled = (qty >= MAX_QTY);
    if (minusBtn) minusBtn.disabled = (qty <= 1);
    if (auditContainer) {
      auditContainer.querySelectorAll('.hb-audit-form__header__remove-btn').forEach(btn => {
        btn.style.display = (qty <= 1) ? 'none' : '';
      });
    }
    // Update "Apply to all/specific Audits" text based on metafield
    const capitalizedLabel = blockLabel.charAt(0).toUpperCase() + blockLabel.slice(1);
    document.querySelectorAll('.hb-audit__all-audits-text').forEach(el => {
      const countSpan = el.querySelector('.hb-audit-count');
      const countVal = countSpan ? countSpan.textContent : qty;
      el.innerHTML = 'Apply to all <span class="hb-audit-count">' + countVal + '</span> ' + capitalizedLabel + 's';
    });
    document.querySelectorAll('.hb-audit__specific-audits-text').forEach(el => {
      el.textContent = 'Apply to Specific ' + capitalizedLabel + 's';
    });
    // Update "Price per audit" label
    const pricePerLabel = document.querySelector('.hb-price-per-label');
    if(document.body.classList.contains("product-landing-page-design")){
      if (pricePerLabel) pricePerLabel.textContent = 'Price';
    }else{
      if (pricePerLabel) pricePerLabel.textContent = 'Price per ' + blockLabel;
    }
  })();

  // ---- #hb-add-url button: increment quantity + duplicate block ----
  if (addUrlBtn && quantityInput) {
    addUrlBtn.addEventListener('click', function () {
      const currentVal = getQuantity();
      const step = parseInt(quantityInput.step) || 1;
      const newVal = Math.min(currentVal + step, MAX_QTY);
      quantityInput.value = newVal;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      syncBlocks(newVal);
    });
  }

  // ---- Swiper card: update audit count & specific audit checkboxes ----
    
  
    
    function updateSwiperAuditOptions(qty){
    document.querySelectorAll('.hb-audit-swiper-main-card').forEach(card => {
      // Update "Apply to all X Audits" text
      const countSpan = card.querySelector('.hb-audit-count');
      if (countSpan) countSpan.textContent = qty;

      // Rebuild specific audit checkboxes
      const specificFields = card.querySelector('.hb-audit__specific-fields');
      if (specificFields) {
        specificFields.innerHTML = '';
        for (let i = 1; i <= qty; i++) {
          const div = document.createElement('div');
          div.className = 'hb-audit__Fields';
          div.innerHTML = '<input type="checkbox" class="hb-specific-audit-checkbox" data-audit-index="' + i + '"> <span>' + blockTitlePrefix + i + '</span>';
          specificFields.appendChild(div);
        }
        // Re-attach change listeners for specific checkboxes
        specificFields.querySelectorAll('.hb-specific-audit-checkbox').forEach(cb => {
          cb.addEventListener('change', updateTotalPrice);
        });
      }
    });
  }

  // ---- Swiper card: radio toggle for apply-to-all vs specific ----
  document.querySelectorAll('.hb-apply-radio').forEach(radio => {
    radio.addEventListener('change', function () {
      const card = this.closest('.hb-audit-swiper-main-card');
      if (!card) return;
      const specificFields = card.querySelector('.hb-audit__specific-fields');
      if (this.value === 'specific') {
        if (specificFields) specificFields.style.display = '';
      } else {
        if (specificFields) specificFields.style.display = 'none';
      }
      updateTotalPrice();
    });
  });

  // ---- Swiper card checkbox change → toggle apply options & update price ----
  document.querySelectorAll('.hb-swiper-card-checkbox').forEach(cb => {
    cb.addEventListener('change', function () {
      const card = this.closest('.hb-audit-swiper-main-card');
      if (card) {
        const applyOptions = card.querySelector('.hb-audit__apply-options');
        if (applyOptions) {
          applyOptions.style.display = this.checked ? 'block' : 'none';
        }
      }
      updateTotalPrice();
    });
  });

  // ---- Addon checkbox → update price ----
  const addonCheckbox = document.getElementById('addon');
  if (addonCheckbox) {
    addonCheckbox.addEventListener('change', updateTotalPrice);
  }

  // ---- Volume discount tiers (applied to main product + addon only) ----
  const discountTiers = [
    { minQty: 10, percent: 30 },
    { minQty: 8,  percent: 25 },
    { minQty: 5,  percent: 20 },
    { minQty: 3,  percent: 15 },
    { minQty: 2,  percent: 10 },
  ];

  function getDiscountPercent(qty) {
    for (const tier of discountTiers) {
      if (qty >= tier.minQty) return tier.percent;
    }
    return 0;
  }

  function getMainPlanCardEls() {
    if (!subRoot) return [];
    return Array.from(subRoot.querySelectorAll('.cus-plan-card:not([js-quaterly])'));
  }

  function hasAnyRequiredMainPlan() {
    return getMainPlanCardEls().some((c) => c.hasAttribute('data-required'));
  }

  function getQuaterlyFieldset() {
    return subRoot ? subRoot.querySelector('.cus-plan-card[js-quaterly]') : null;
  }

  /** On load: third requires second; unchecking second clears third. */
  function syncPlanIndexSecondThirdOnInit() {
    if (!subRoot || !hasAnyRequiredMainPlan()) return;
    const main = getMainPlanCardEls();
    const second = main.find((c) => c.getAttribute('data-plan-index') === '1');
    const third = main.find((c) => c.getAttribute('data-plan-index') === '2');
    if (!second || !third) return;
    const cb2 = second.querySelector('.cus-plan-card__checkbox');
    const cb3 = third.querySelector('.cus-plan-card__checkbox');
    if (!cb2 || !cb3) return;
    if (cb3.checked && !cb2.checked) cb2.checked = true;
    if (!cb2.checked) cb3.checked = false;
  }

  function ensureRequiredPlanCardsChecked() {
    if (!subRoot) return;
    getMainPlanCardEls().forEach((c) => {
      if (c.hasAttribute('data-required')) {
        const x = c.querySelector('.cus-plan-card__checkbox');
        if (x) x.checked = true;
      }
    });
    const qf = getQuaterlyFieldset();
    if (qf && qf.hasAttribute('data-required')) {
      const x = qf.querySelector('.cus-plan-card__checkbox');
      if (x) x.checked = true;
    }
  }

  function initSubscriptionPlanControls() {
    if (!subRoot) return;
    const main = getMainPlanCardEls();
    if (!main.length) return;
    if (hasAnyRequiredMainPlan()) {
      syncPlanIndexSecondThirdOnInit();
    } else {
      const checked = main.filter((c) => c.querySelector('.cus-plan-card__checkbox') && c.querySelector('.cus-plan-card__checkbox').checked);
      if (checked.length === 0) {
        const pick = main.find((c) => c.hasAttribute('data-checked')) || main[0];
        main.forEach((c) => {
          const x = c.querySelector('.cus-plan-card__checkbox');
          if (x) x.checked = c === pick;
        });
      } else if (checked.length > 1) {
        const keep = main.find((c) => c.hasAttribute('data-checked')) || checked[0];
        main.forEach((c) => {
          const x = c.querySelector('.cus-plan-card__checkbox');
          if (x) x.checked = c === keep;
        });
      }
    }
    ensureRequiredPlanCardsChecked();
    subRoot.addEventListener('change', onSubscriptionCardChange);
  }

  function onSubscriptionCardChange(e) {
    if (!e.target || !e.target.classList || !e.target.classList.contains('cus-plan-card__checkbox')) return;
    const card = e.target.closest('.cus-plan-card');
    if (!card || !subRoot || !subRoot.contains(card)) return;
    if (card.hasAttribute('data-required') && !e.target.checked) {
      e.target.checked = true;
      return;
    }
    if (card.hasAttribute('js-quaterly')) {
      updateTotalPrice();
      return;
    }
    if (!hasAnyRequiredMainPlan()) {
      if (!e.target.checked) {
        e.target.checked = true;
        return;
      }
      getMainPlanCardEls().forEach((c) => {
        const cb = c.querySelector('.cus-plan-card__checkbox');
        if (c !== card && cb) cb.checked = false;
      });
    } else {
      const idx = String(card.getAttribute('data-plan-index') || '');
      if (idx === '1' && e.target.checked === false) {
        const thirdC = getMainPlanCardEls().find((c) => c.getAttribute('data-plan-index') === '2');
        const tcb = thirdC && thirdC.querySelector('.cus-plan-card__checkbox');
        if (tcb) tcb.checked = false;
      } else if (idx === '2' && e.target.checked) {
        const secondC = getMainPlanCardEls().find((c) => c.getAttribute('data-plan-index') === '1');
        const sbc = secondC && secondC.querySelector('.cus-plan-card__checkbox');
        if (sbc) sbc.checked = true;
      }
    }
    updateTotalPrice();
  }

  function updateSubscriptionLineItemsAndAccordions() {
    if (!subRoot) return;
    const main = getMainPlanCardEls();
    const selected = main
      .filter((c) => {
        const cb = c.querySelector('.cus-plan-card__checkbox');
        return cb && cb.checked;
      })
      .map((c) => String(c.getAttribute('data-plan-index') || ''));

    subRoot.querySelectorAll('[data-plan-accordion-for]').forEach((acc) => {
      const idx = acc.getAttribute('data-plan-accordion-for');
      const show = selected.indexOf(idx) !== -1;
      acc.classList.toggle('is-hidden', !show);
    });

    const wrap = subRoot.querySelector('#hb-subscription-line-items') || document.getElementById('hb-subscription-line-items');
    const labelEl = subRoot.querySelector('#hb-price-per-label-text') || document.getElementById('hb-price-per-label-text');
    const ppa = subRoot.querySelector('#hb-price-per-audit') || document.getElementById('hb-price-per-audit');
    if (wrap) {
      let html = '';
      main
        .filter((c) => c.querySelector('.cus-plan-card__checkbox') && c.querySelector('.cus-plan-card__checkbox').checked)
        .forEach((c) => {
          const titleEl = c.querySelector('.cus-subscription-plan__product-title');
          const title = titleEl ? titleEl.textContent : '';
          const isReq = c.hasAttribute('data-required');
          const cb = c.querySelector('.cus-plan-card__checkbox');
          const cents = Number((cb && cb.dataset.productPrice) || 0) || 0;
          const st = (c.getAttribute('data-subscription') || 'one-time').toLowerCase();
          const t = (title || '').replace(/\s+/g, ' ').trim();
          const titlePart = t + (isReq ? ' (Required)' : '');
          let priceSuffix = ' ' + st;
          if (st === 'monthly') priceSuffix = ' /mo';
          else if (st === 'quarterly' || st === 'quaterly') priceSuffix = ' /qtr';
          const pricePart = formatMoney(cents) + priceSuffix;
          html +=
            '<div class="hb-subscription-line__item hb-text">' +
            '<span class="hb-subscription-line__title">' +
            titlePart +
            '</span>' +
            '<span class="hb-subscription-line__price">' +
            pricePart +
            '</span>' +
            '</div>';
        });
      const adBudgetLineTotal = getAdBudgetTotalCents();
      if (adBudgetLineTotal > 0) {
        html +=
          '<div class="hb-subscription-line__item hb-text">' +
          '<span class="hb-subscription-line__title">First Month (Ad Spend + Management)</span>' +
          '<span class="hb-subscription-line__price">' +
          formatMoney(adBudgetLineTotal) +
          '</span>' +
          '</div>';
      }
      wrap.innerHTML = html;
      wrap.style.display = html ? 'block' : 'none';
    }
    if (labelEl) labelEl.style.display = 'none';
    if (ppa) ppa.style.display = 'none';

    const qf = getQuaterlyFieldset();
    const qrow = (subRoot && subRoot.querySelector('#hb-quaterly-add-on-row')) || document.getElementById('hb-quaterly-add-on-row');
    const qcb = qf ? qf.querySelector('.cus-plan-card__checkbox') : null;
    if (qrow && qf) {
      const tEl = (subRoot && subRoot.querySelector('#hb-quaterly-add-on__title')) || document.getElementById('hb-quaterly-add-on__title');
      const pEl = (subRoot && subRoot.querySelector('#hb-quaterly-add-on__price')) || document.getElementById('hb-quaterly-add-on__price');
      if (qcb && qcb.checked) {
        qrow.style.display = '';
        const tNode = qf.querySelector('.cus-subscription-plan__product-title');
        if (tEl) tEl.textContent = tNode ? tNode.textContent : '';
        const centsQ = Number((qcb && qcb.dataset.productPrice) || 0) || 0;
        if (pEl) pEl.textContent = formatMoney(centsQ) + ' /qtr';
      } else {
        qrow.style.display = 'none';
      }
    }
  }

  // ---- Ad budget slider (.hb_ad-budget): qty from range, 80/20 split, add to subscription total ----
  function getAdBudgetContext() {
    if (!subRoot) return null;
    const root = subRoot.querySelector('.hb_ad-budget');
    if (!root) return null;
    const slider = root.querySelector('#budgetSlider');
    if (!slider) return null;
    const u = parseInt(root.getAttribute('data-budget-unit-cents'), 10) || 0;
    if (!u) return null;
    const minAd = parseInt(root.getAttribute('data-budget-min-ad-cents'), 10);
    const maxAd = parseInt(root.getAttribute('data-budget-max-ad-cents'), 10);
    return {
      root: root,
      slider: slider,
      u: u,
      minAd: isNaN(minAd) ? 30000 : minAd,
      maxAd: isNaN(maxAd) ? 1000000 : maxAd
    };
  }

  function getAdBudgetTotalCents() {
    const ctx = getAdBudgetContext();
    if (!ctx) return 0;
    const q = parseInt(ctx.slider.value, 10) || 0;
    return q * ctx.u;
  }

  function updateAdBudgetDisplay() {
    const ctx = getAdBudgetContext();
    if (!ctx) return;
    const q = parseInt(ctx.slider.value, 10) || 0;
    const total = q * ctx.u;
    // Fee = 1/6 (~16.67%) of line total; ad spend = remainder (5/6), e.g. $3.60 → $0.60 / $3.00
    const fee = Math.round(total * (1 / 6));
    const adSpend = total - fee;
    const adEl = ctx.root.querySelector('#adSpend');
    const adBudEl = ctx.root.querySelector('#budgetValue');
    const feeEl = ctx.root.querySelector('#fee');
    const totEl = ctx.root.querySelector('#total');
    if (adEl) adEl.textContent = formatMoney(adSpend);
    if (adBudEl) adBudEl.textContent = formatMoney(adSpend);
    if (feeEl) feeEl.textContent = formatMoney(fee);
    if (totEl) totEl.textContent = formatMoney(total);
  }

  function initAdBudgetSlider() {
    const ctx = getAdBudgetContext();
    if (!ctx) return;
    if (ctx.slider.getAttribute('data-budget-listeners') === '1') return;
    // #adSpend is 5/6 of (qty × unit); keep that amount within min/max ad (same $300–$10k UI bounds)
    const minQ = Math.ceil((ctx.minAd * 6) / (5 * ctx.u));
    const maxQ = Math.floor((ctx.maxAd * 6) / (5 * ctx.u));
    const safeMin = Math.max(1, minQ);
    const safeMax = Math.max(safeMin, maxQ);
    ctx.slider.setAttribute('min', String(safeMin));
    ctx.slider.setAttribute('max', String(safeMax));
    const cur = parseInt(ctx.slider.value, 10);
    if (isNaN(cur) || cur < safeMin || cur > safeMax) {
      ctx.slider.value = String(safeMin);
    }
    ctx.slider.setAttribute('data-budget-initialized', '1');
    ctx.slider.setAttribute('data-budget-listeners', '1');
    ctx.slider.addEventListener('input', updateTotalPrice);
    ctx.slider.addEventListener('change', updateTotalPrice);
  }

  // ---- Calculate and update total price ----
  function updateTotalPrice() {
    if (subRoot) {
      const qtyS = getQuantity();
      const discountPctS = getDiscountPercent(qtyS);
      updateSubscriptionLineItemsAndAccordions();

      let sumSel = 0;
      getMainPlanCardEls().forEach((c) => {
        const cb = c.querySelector('.cus-plan-card__checkbox');
        if (cb && cb.checked) sumSel += Number(cb.dataset.productPrice) || 0;
      });
      const qF = getQuaterlyFieldset();
      const qBox = qF ? qF.querySelector('.cus-plan-card__checkbox') : null;
      if (qBox && qBox.checked) {
        sumSel += Number(qBox.dataset.productPrice) || 0;
      }
      const addonP = (addonCheckbox && addonCheckbox.checked)
        ? (Number(addonCheckbox.dataset.productPrice) || 0)
        : 0;
      const perAuditOrigS = sumSel + addonP;
      const perAuditFinS = discountPctS > 0
        ? Math.round(perAuditOrigS * (100 - discountPctS) / 100)
        : perAuditOrigS;
      const mainTotalS = perAuditFinS * qtyS;
      const mainOrigTotalS = perAuditOrigS * qtyS;
      const discAmtS = mainOrigTotalS - mainTotalS;

      let swiperTotalS = 0;
      (subRoot ? subRoot.querySelectorAll('.hb-audit-swiper-main-card') : []).forEach((card) => {
        const cb = card.querySelector('.hb-swiper-card-checkbox');
        const discountRow = card.querySelector('.hb-swiper-card__discount-row');
        if (!cb || !cb.checked) {
          if (discountRow) discountRow.style.display = 'none';
          return;
        }
        const cardPrice = Number(cb.dataset.productPrice) || 0;
        const applyAll = card.querySelector('.hb-apply-radio[value="all"]');
        let cardQty = qtyS;
        if (!(applyAll && applyAll.checked)) {
          cardQty = card.querySelectorAll('.hb-specific-audit-checkbox:checked').length;
        }
        const cardOriginal = cardPrice * cardQty;
        const cardDiscountPct = getDiscountPercent(cardQty);
        const cardFinal = cardOriginal - Math.round(cardOriginal * cardDiscountPct / 100);
        swiperTotalS += cardFinal;
        if (discountRow) {
          if (cardQty > 0) {
            discountRow.style.display = '';
            const origEl = discountRow.querySelector('.hb-swiper-card__original-price');
            const finalEl = discountRow.querySelector('.hb-swiper-card__discounted-price');
            const badgeEl = discountRow.querySelector('.hb-swiper-card__discount-badge');
            if (cardDiscountPct > 0) {
              if (origEl) { origEl.textContent = formatMoney(cardOriginal); origEl.style.display = ''; }
              if (finalEl) finalEl.textContent = formatMoney(cardFinal);
              if (badgeEl) { badgeEl.textContent = cardDiscountPct + '% off'; badgeEl.style.display = ''; }
            } else {
              if (origEl) origEl.style.display = 'none';
              if (finalEl) finalEl.textContent = formatMoney(cardFinal);
              if (badgeEl) badgeEl.style.display = 'none';
            }
          } else {
            discountRow.style.display = 'none';
          }
        }
      });

      const adBudgetCents = getAdBudgetTotalCents();
      const grandTotalS = mainTotalS + swiperTotalS + adBudgetCents;
      updateAdBudgetDisplay();
      const addonsRowS = document.getElementById('hb-addons-row');
      const addonsPriceElS = document.getElementById('hb-addons-price');
      if (addonsRowS && addonsPriceElS) {
        if (swiperTotalS > 0) {
          addonsRowS.style.display = '';
          addonsPriceElS.textContent = formatMoney(swiperTotalS);
        } else {
          addonsRowS.style.display = 'none';
        }
      }
      const discountBannerS = document.getElementById('hb-volume-discount');
      if (discountBannerS) {
        if (discountPctS > 0) {
          discountBannerS.style.display = '';
          const pctElS = document.getElementById('hb-discount-percent');
          const savingElS = document.getElementById('hb-discount-saving');
          if (pctElS) pctElS.textContent = discountPctS + '%';
          if (savingElS) savingElS.textContent = formatMoney(discAmtS);
        } else {
          discountBannerS.style.display = 'none';
        }
      }
      const orderTotalElS = document.getElementById('hb-order-total');
      if (orderTotalElS) orderTotalElS.textContent = formatMoney(grandTotalS);
      document.querySelectorAll('.hb-service-cta__button-price').forEach(function (el) {
        el.textContent = formatMoney(grandTotalS);
      });
      if (priceEl) priceEl.textContent = formatMoney(grandTotalS);
      const serviceTotalElS = document.getElementById('total-price');
      if (serviceTotalElS) serviceTotalElS.textContent = formatMoney(grandTotalS);
      return;
    }
    const qty = getQuantity();
    const discountPct = getDiscountPercent(qty);

    // Per-audit price = main product + video walkthrough (if checked)
    const addonPrice = (addonCheckbox && addonCheckbox.checked)
      ? (Number(addonCheckbox.dataset.productPrice) || 0)
      : 0;
    const perAuditOriginal = mainProductPrice + addonPrice;
    const perAuditFinal = discountPct > 0
      ? Math.round(perAuditOriginal * (100 - discountPct) / 100)
      : perAuditOriginal;

    // Main total (main product + video walkthrough, after discount)
    const mainTotal = perAuditFinal * qty;
    const mainOriginalTotal = perAuditOriginal * qty;
    const discountAmount = mainOriginalTotal - mainTotal;

    // Swiper card products (discounted based on their own audit count)
    let swiperTotal = 0;
    document.querySelectorAll('.hb-audit-swiper-main-card').forEach(card => {
      const cb = card.querySelector('.hb-swiper-card-checkbox');
      const discountRow = card.querySelector('.hb-swiper-card__discount-row');
      if (!cb || !cb.checked) {
        if (discountRow) discountRow.style.display = 'none';
        return;
      }
      const cardPrice = Number(cb.dataset.productPrice) || 0;
      const applyAll = card.querySelector('.hb-apply-radio[value="all"]');
      let cardQty = qty;
      if (!(applyAll && applyAll.checked)) {
        cardQty = card.querySelectorAll('.hb-specific-audit-checkbox:checked').length;
      }
      const cardOriginal = cardPrice * cardQty;
      const cardDiscountPct = getDiscountPercent(cardQty);
      const cardDiscountAmt = Math.round(cardOriginal * cardDiscountPct / 100);
      const cardFinal = cardOriginal - cardDiscountAmt;
      swiperTotal += cardFinal;

      // Update per-card discount display
      if (discountRow) {
        if (cardQty > 0) {
          discountRow.style.display = '';
          const origEl = discountRow.querySelector('.hb-swiper-card__original-price');
          const finalEl = discountRow.querySelector('.hb-swiper-card__discounted-price');
          const badgeEl = discountRow.querySelector('.hb-swiper-card__discount-badge');
          if (cardDiscountPct > 0) {
            if (origEl) { origEl.textContent = formatMoney(cardOriginal); origEl.style.display = ''; }
            if (finalEl) finalEl.textContent = formatMoney(cardFinal);
            if (badgeEl) { badgeEl.textContent = cardDiscountPct + '% off'; badgeEl.style.display = ''; }
          } else {
            if (origEl) origEl.style.display = 'none';
            if (finalEl) finalEl.textContent = formatMoney(cardFinal);
            if (badgeEl) badgeEl.style.display = 'none';
          }
        } else {
          discountRow.style.display = 'none';
        }
      }
    });

    const grandTotal = mainTotal + swiperTotal;

    // Update price per audit — show discounted price directly if discount applies
    const pricePerAuditEl = document.getElementById('hb-price-per-audit');
    if (pricePerAuditEl) {
      if (discountPct > 0) {
        pricePerAuditEl.innerHTML =
          '<span class="hb-price-original">' + formatMoney(perAuditOriginal) + '</span> ' +
          '<span class="hb-price-discounted">' + formatMoney(perAuditFinal) + '</span>';
      } else {
        pricePerAuditEl.textContent = formatMoney(perAuditOriginal);
      }
    }

    // Update add-ons row (only swiper card products, NOT video walkthrough)
    const addonsRow = document.getElementById('hb-addons-row');
    const addonsPriceEl = document.getElementById('hb-addons-price');
    if (addonsRow && addonsPriceEl) {
      if (swiperTotal > 0) {
        addonsRow.style.display = '';
        addonsPriceEl.textContent = formatMoney(swiperTotal);
      } else {
        addonsRow.style.display = 'none';
      }
    }

    // Update quantity audits label
    const qtyAuditsLabel = document.getElementById('hb-qty-audits-label');
    if (qtyAuditsLabel) {
      qtyAuditsLabel.textContent = qty + (qty === 1 ? ' ' + blockLabel : ' ' + blockLabel + 's');
    }

    // Update discount banner (shows main discount % and total savings)
    const discountBanner = document.getElementById('hb-volume-discount');
    if (discountBanner) {
      if (discountPct > 0) {
        discountBanner.style.display = '';
        const pctEl = document.getElementById('hb-discount-percent');
        const savingEl = document.getElementById('hb-discount-saving');
        if (pctEl) pctEl.textContent = discountPct + '%';
        if (savingEl) savingEl.textContent = formatMoney(discountAmount);
      } else {
        discountBanner.style.display = 'none';
      }
    }

    // Update total display
    const orderTotalEl = document.getElementById('hb-order-total');
    if (orderTotalEl) {
      orderTotalEl.textContent = formatMoney(grandTotal);
    }
    document.querySelectorAll('.hb-service-cta__button-price').forEach(function (el) {
      el.textContent = formatMoney(grandTotal);
    });
    if (priceEl) {
      priceEl.textContent = formatMoney(grandTotal);
    }
    // Also update service card total if present
    const serviceTotalEl = document.getElementById('total-price');
    if (serviceTotalEl) {
      serviceTotalEl.textContent = formatMoney(grandTotal);
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ---- CUSTOM ADD TO CART (override form submit) ----
  const submitBtn = productForm.querySelector('.product-form__submit');
  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.getAttribute('aria-disabled') === 'true' || this.disabled) return;

      this.setAttribute('aria-disabled', 'true');
      this.classList.add('loading');
      const spinner = this.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

           if (!validateAuditBlockUrlFields()) {
        resetButton(this);
        return;
      }

      if (!validateAuditOtherFields()) {
        resetButton(this);
        return;
      }

      const addToCartBtn = this;
      hbValidateNoCartDuplicates().then((ok) => {
        if (!ok) {
          resetButton(addToCartBtn);
          return;
        }

        const items = buildCartItems();
        if (items.length === 0) {
          resetButton(addToCartBtn);
          return;
        }

        addItemsToCart(items).then(() => {
          resetButton(addToCartBtn);
        });
      });
    });
  }

  // Also prevent the native form submit
  productForm.addEventListener('submit', function (e) {
    e.preventDefault();
  });

  // ---- BUY IT NOW: intercept dynamic checkout button ----
  function interceptBuyItNow() {
    const buyNowBtn = productForm.querySelector('.shopify-payment-button__button');
    if (!buyNowBtn) {
      // Shopify injects this button async, retry
      setTimeout(interceptBuyItNow, 500);
      return;
    }
    buyNowBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

           if (!validateAuditBlockUrlFields()) return;

      if (!validateAuditOtherFields()) return;

      const items = buildCartItems();
      if (items.length === 0) return;

      // Show loading state
      buyNowBtn.setAttribute('aria-disabled', 'true');
      buyNowBtn.style.opacity = '0.6';
      buyNowBtn.style.pointerEvents = 'none';
      buyNowBtn.dataset.originalText = buyNowBtn.textContent;
      buyNowBtn.textContent = 'checking cart...';

      function resetBuyNowBtn() {
        buyNowBtn.textContent = buyNowBtn.dataset.originalText;
        buyNowBtn.removeAttribute('aria-disabled');
        buyNowBtn.style.opacity = '';
        buyNowBtn.style.pointerEvents = '';
      }

      hbValidateNoCartDuplicates().then((ok) => {
        if (!ok) {
          resetBuyNowBtn();
          return;
        }

        buyNowBtn.textContent = 'adding...';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(res => res.json())
        .then(response => {
          if (response.status) {
            console.error('Cart error:', response.description);
            resetBuyNowBtn();
            return;
          }
          window.location = window.Shopify.routes.root + 'checkout';
        })
        .catch(err => {
          console.error('Buy it now error:', err);
          resetBuyNowBtn();
        });
      });
    }, true);

    }
    
  interceptBuyItNow();

  function resetButton(btn) {
    btn.classList.remove('loading');
    btn.removeAttribute('aria-disabled');
    const spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.add('hidden');
  }

  function buildCartItemsForSubscription() {
    const out = [];
    if (!subRoot) return out;
    const main = getMainPlanCardEls();
    const selected = main.filter((c) => {
      const cb = c.querySelector('.cus-plan-card__checkbox');
      return cb && cb.checked;
    });
    if (!selected.length) return out;
    const hasReqInTheme = hasAnyRequiredMainPlan();
    const blockElements = auditContainer ? auditContainer.querySelectorAll('.hb-audit__block') : [];
    const blockList = blockElements.length ? Array.from(blockElements) : [null];
    blockList.forEach((block) => {
      const fullProperties = block ? collectBlockProperties(block) : {};
      selected.forEach((card) => {
        const cbx = card.querySelector('.cus-plan-card__checkbox');
        const vid = cbx ? Number(cbx.dataset.productId) : 0;
        if (!vid) return;
        let lineProps;
        if (!hasReqInTheme) {
          lineProps = Object.assign({}, fullProperties);
        } else if (card.hasAttribute('data-required')) {
          lineProps = Object.assign({}, fullProperties);
        } else {
          lineProps = {};
        }
        out.push({ id: vid, quantity: 1, properties: lineProps });
      });
    });
    const qf = getQuaterlyFieldset();
    const qcb = qf ? qf.querySelector('.cus-plan-card__checkbox') : null;
    if (qcb && qcb.checked) {
      const qid = Number(qcb.dataset.productId);
      if (qid) {
        const q = getQuantity();
        out.push({ id: qid, quantity: q, properties: { 'Add-on type': 'Quarterly' } });
      }
    }
    const qty = getQuantity();
    subRoot.querySelectorAll('.hb-audit-swiper-main-card').forEach((card) => {
      const cb = card.querySelector('.hb-swiper-card-checkbox');
      if (!cb || !cb.checked) return;
      const cardVariantId = Number(cb.dataset.productId);
      if (!cardVariantId) return;
      const applyAll = card.querySelector('.hb-apply-radio[value="all"]');
      const properties = {};
      let cardQty = qty;
      if (applyAll && !applyAll.checked) {
        const checkedAudits = card.querySelectorAll('.hb-specific-audit-checkbox:checked');
        cardQty = checkedAudits.length;
        const auditNumbers = Array.from(checkedAudits).map((c2) => c2.dataset.auditIndex);
        properties['Applied to'] = blockTitlePrefix + auditNumbers.join(', ' + blockTitlePrefix);
      } else {
        properties['Applied to'] = 'All ' + blockLabel.charAt(0).toUpperCase() + blockLabel.slice(1) + 's (1-' + qty + ')';
      }
      if (cardQty > 0) {
        out.push({ id: cardVariantId, quantity: cardQty, properties: properties });
      }
    });
    if (addonCheckbox && addonCheckbox.checked) {
      const addonVariantId = Number(addonCheckbox.dataset.productId);
      if (addonVariantId) {
        const q2 = getQuantity();
        out.push({
          id: addonVariantId,
          quantity: q2,
          properties: {
            'For': q2 === 1 ? '1 ' + blockLabel : 'all ' + q2 + ' ' + blockLabel + 's'
          }
        });
      }
    }
    const adCtx = getAdBudgetContext();
    if (adCtx) {
      const av = parseInt(adCtx.root.getAttribute('data-budget-variant-id'), 10);
      const bq = parseInt(adCtx.slider.value, 10) || 0;
      if (av && bq > 0) {
        const lineTotalCents = bq * adCtx.u;
        const feeCents = Math.round(lineTotalCents * (1 / 6));
        const adSpendCents = lineTotalCents - feeCents;
        out.push({
          id: av,
          quantity: bq,
          properties: {
            'Management Fee': formatMoney(feeCents),
            'Ad Spend': formatMoney(adSpendCents)
          }
        });
      }
    }
    return out;
  }

  function buildCartItems() {
    if (subRoot) {
      return buildCartItemsForSubscription();
    }
    const items = [];
    const qty = getQuantity();
    const variantInput = productForm.querySelector('.product-variant-id');
    const mainVariantId = variantInput ? Number(variantInput.value) : null;
    if (!mainVariantId) return items;

    // One cart line per audit block, or a single line when there is no .hb-audit-container / no blocks
    const blockElements = auditContainer ? auditContainer.querySelectorAll('.hb-audit__block') : [];
    const blockList = blockElements.length ? Array.from(blockElements) : [null];
    blockList.forEach((block) => {
      const properties = block ? collectBlockProperties(block) : {};
      items.push({
        id: mainVariantId,
        quantity: 1,
        properties: properties
      });
    });

    // Addon product (qty matches main product)
    if (addonCheckbox && addonCheckbox.checked) {
      const addonVariantId = Number(addonCheckbox.dataset.productId);
      if (addonVariantId) {
        items.push({
          id: addonVariantId,
          quantity: qty,
          properties: {
            'For': qty === 1 ? '1 ' + blockLabel : 'all ' + qty + ' ' + blockLabel + 's'
          }
        });
      }
    }

    // Swiper card products
    document.querySelectorAll('.hb-audit-swiper-main-card').forEach(card => {
      const cb = card.querySelector('.hb-swiper-card-checkbox');
      if (!cb || !cb.checked) return;
      const cardVariantId = Number(cb.dataset.productId);
      if (!cardVariantId) return;

      const applyAll = card.querySelector('.hb-apply-radio[value="all"]');
      const properties = {};
      let cardQty = qty;

      if (applyAll && applyAll.checked) {
        properties['Applied to'] = 'All ' + blockLabel.charAt(0).toUpperCase() + blockLabel.slice(1) + 's (1-' + qty + ')';
      } else {
        const checkedAudits = card.querySelectorAll('.hb-specific-audit-checkbox:checked');
        cardQty = checkedAudits.length;
        const auditNumbers = Array.from(checkedAudits).map(cb => cb.dataset.auditIndex);
        properties['Applied to'] = blockTitlePrefix + auditNumbers.join(', ' + blockTitlePrefix);
      }

      if (cardQty > 0) {
        items.push({
          id: cardVariantId,
          quantity: cardQty,
          properties: properties
        });
      }
    });

    return items;
  }

  function addItemsToCart(items) {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');
    const cart = cartDrawer || cartNotification;

    return shopifyFetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(res => res.json())
    .then(response => {
      if (response.status) {
        console.error('Cart error:', response.description);
        return;
      }

      // Get the key of the last added item (needed by cart-notification)
      const lastItemKey = response.items && response.items.length > 0
        ? response.items[response.items.length - 1].key
        : null;

      if (cart) {
        // Use Shopify Section Rendering API to get updated cart drawer HTML
        const sectionIds = cart.getSectionsToRender().map(s => s.id);
        const params = sectionIds.map(id => 'sections[]=' + encodeURIComponent(id)).join('&');
        return shopifyFetch(window.Shopify.routes.root + 'cart?' + params)
          .then(r => r.json())
          .then(sectionsData => {
            // Remove is-empty classes so drawer shows cart items
            cart.classList.remove('is-empty');
            const drawerItems = cart.querySelector('cart-drawer-items');
            if (drawerItems) drawerItems.classList.remove('is-empty');
            const drawerInner = cart.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.remove('is-empty');

            cart.renderContents({ key: lastItemKey, sections: sectionsData });

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'hb-product-form',
                cartData: { sections: sectionsData },
              });
            }
          });
      } else {
        window.location = window.Shopify.routes.root + 'cart';
      }
    })
    .catch(err => {
      console.error('Add to cart error:', err);
    });
  }

  // ---- Init: run once on load ----
  if (subRoot) {
    initSubscriptionPlanControls();
    initAdBudgetSlider();
  }
  syncBlocks(getQuantity());  
  updateSwiperAuditOptions(getQuantity());
  updateTotalPrice();
  initAuditOtherFields();
});

/* BZ 2026-10-19: Landing Page Design, platform "Other" makes the order design only. Remove this line to undo. */;(function(){if(!document.body.classList.contains('product-landing-page-design'))return;var grid=document.querySelector('.hb-packages__grid');if(!grid)return;var pk=grid.querySelectorAll('[data-hb-package]');var note=document.createElement('div');note.hidden=true;note.style.cssText='font-size:14px;line-height:1.55;color:#C4C4C4;background:rgba(0,91,211,.08);border:1px solid rgba(0,110,255,.35);border-radius:10px;padding:12px 14px;margin-top:12px';note.textContent='Your platform is one we do not build on, so your order is design only. We deliver the approved design files and a developer handoff instead.';grid.parentNode.insertBefore(note,grid.nextSibling);var steps={};document.querySelectorAll('.hb-timeline__step').forEach(function(li){var t=li.querySelector('.hb-timeline__title'),x=li.querySelector('.hb-timeline__text');if(t&&x)steps[t.textContent.trim()]={li:li,x:x,o:x.textContent};});function blocked(){var r=document.querySelector('input[name="your-platform"]:checked');return !!r&&/^Other/.test(r.value);}function sync(){var b=blocked(),p0=pk[0],p1=pk[1];if(b&&p1&&!p1.checked){p1.checked=true;p1.dispatchEvent(new Event('change',{bubbles:true}));}if(p0){p0.disabled=b;p0.closest('.hb-package').style.opacity=b?'.45':'';}note.hidden=!b;var building=!b&&p0&&p0.checked;var s=steps['Build'];if(s){s.x.textContent=building?s.o:'Not included';s.li.style.opacity=building?'':'.4';}var l=steps['Live'];if(l)l.x.textContent=building?l.o:'Design files delivered';}document.addEventListener('change',function(e){if(e.target.name==='your-platform'||e.target.matches('[data-hb-package]'))setTimeout(sync,0);});sync();setTimeout(sync,1500);})();
/* BZ 2026-10-19: Complete Shopify Store Setup, extra products start at 1 as in the design. Remove this line to undo. */;(function(){if(!document.body.classList.contains('product-complete-shopify-store-setup'))return;function go(){var q=document.querySelector('[data-hb-qty] .qty-input');if(!q||q.value!=='0')return;q.value='1';q.dispatchEvent(new Event('input',{bubbles:true}));q.dispatchEvent(new Event('change',{bubbles:true}));}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(go,0);});else setTimeout(go,0);})();
/* BZ 2026-10-19: Conversion Tracking Setup, design texts and empty order state. Remove this line to undo. */;(function(){if(!document.body.classList.contains('product-conversion-tracking-setup'))return;function go(){var st=document.querySelector('.hb-hero-panel__stats');if(st&&!document.querySelector('.bz-ct-dns')){var p=document.createElement('p');p.className='bz-ct-dns';p.style.cssText='margin:14px 0 0;font-size:14px;line-height:1.55;color:#949494';p.textContent='Server-side adds a few days because it needs a DNS change on your domain, and your registrar sets that pace, not us.';st.parentNode.insertBefore(p,st.nextSibling);}document.querySelectorAll('.hb-bundle__title').forEach(function(t){if(t.textContent.trim()==='Tracking Walkthrough, optional')t.textContent='Add the Tracking Walkthrough, optional';});var bt=document.querySelector('.hb-service-cta__bottom-text');if(bt&&!document.querySelector('.bz-ct-cross')){var c=document.createElement('p');c.className='bz-ct-cross';c.style.cssText='margin:14px 0 0;font-size:14px;line-height:1.55;color:#949494';c.innerHTML='Not sure what to fix once you can see the numbers? Our <a href="/products/landing-page-audit" style="color:#4d9bff">Landing Page Audit</a>, <a href="/products/seo-audit" style="color:#4d9bff">SEO Audit</a> and <a href="/products/ui-ux-review" style="color:#4d9bff">UI/UX Review</a> each tell you what to do next.';bt.parentNode.insertBefore(c,bt.nextSibling);}var hero=document.querySelector('.hb-hero-panel__top');var from=hero&&(hero.textContent.match(/From (\$[\d,.]+)/)||[])[1];function sync(){var lines=document.querySelector('.hb-bundle__summary-lines');var sum=document.querySelector('.hb-bundle__summary');var buy=document.querySelector('.hb-bundle__buy-now');if(!lines||!sum)return;var none=!lines.querySelector('.hb-bundle__summary-line:not(.bz-ct-inc)');var lab=sum.querySelector('.hb-bundle__summary-label');if(lab&&lab.textContent!=='Total, paid once')lab.textContent='Total, paid once';var note=sum.querySelector('.hb-bundle__addons-summary-note');if(note&&note.style.display!=='none')note.style.display='none';var dv=none?'none':'';if(sum.style.display!==dv)sum.style.display=dv;if(buy&&buy.disabled!==none){buy.disabled=none;buy.style.opacity=none?'.45':'';buy.style.cursor=none?'not-allowed':'';}var inc=lines.querySelector('.bz-ct-inc');if(none&&inc)inc.remove();if(!none&&!inc){inc=document.createElement('div');inc.className='hb-bundle__summary-line bz-ct-inc';inc.style.cssText='display:flex;justify-content:space-between;gap:14px;font-weight:600;padding:9px 12px;margin:6px 0 0;border-radius:8px;background:rgba(0,91,211,.12);border:1px solid rgba(0,110,255,.35)';inc.innerHTML='<span>Setup report, with test evidence and scores</span><span style="color:#4d9bff;white-space:nowrap">Included</span>';lines.appendChild(inc);}else if(inc&&inc!==lines.lastElementChild){lines.appendChild(inc);}var cp=document.querySelector('.hb-service-cta__button-price');if(cp&&from&&/^\$0\.00$/.test(cp.textContent.trim()))cp.textContent='From '+from;}sync();var box=document.querySelector('.hb-service-layout__sidebar');var tm;var mo=new MutationObserver(function(){clearTimeout(tm);tm=setTimeout(sync,30);});if(box)mo.observe(box,{childList:true,subtree:true,characterData:true});var cta=document.querySelector('.hb-service-cta');if(cta)mo.observe(cta,{childList:true,subtree:true,characterData:true});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(go,0);});else setTimeout(go,0);})();
/* BZ 2026-10-19: Local SEO, Access step shows the manager access status as in the design. Remove this line to undo. */;(function(){if(!document.body.classList.contains('product-local-seo-services'))return;function go(){document.querySelectorAll('[data-hb-intake-step]').forEach(function(s){var t=s.querySelector('.hb-intake-step__title');var b=s.querySelector('.hb-intake-task__badge');if(!t||t.textContent.trim()!=='Access'||!b)return;var h=s.querySelector('.hb-intake-step__heading');var el=document.createElement('span');el.className='bz-acc-sum';el.style.cssText='display:block;flex-basis:100%;margin-top:4px;font-size:13px;font-weight:400;color:#949494;letter-spacing:0;text-transform:none';h.appendChild(el);function up(){var v='Manager access: '+b.textContent.trim().toLowerCase();if(el.textContent!==v)el.textContent=v;}up();new MutationObserver(up).observe(b,{childList:true,characterData:true,subtree:true});});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(go,0);});else setTimeout(go,0);})();
/* BZ 2026-10-19: Show all buttons for the new service-v2 sections, and the Google Ads hero price and tier cells. Remove this line to undo. */;(function(){document.addEventListener('click',function(e){var b=e.target.closest('[data-bz-toggle]');if(!b)return;var box=b.closest('.bz-receive,.bz-money');if(!box)return;var open=b.getAttribute('aria-expanded')!=='true';box.querySelectorAll('[data-bz-more]').forEach(function(x){x.hidden=!open;});b.setAttribute('aria-expanded',open?'true':'false');b.textContent=open?b.getAttribute('data-hide'):b.getAttribute('data-show');});if(!document.body.classList.contains('product-google-ads-management'))return;function go(){var root=document.getElementById('hbOrderV2');if(!root)return;var data;try{data=JSON.parse(root.querySelector('[data-hb-order-data]').textContent);}catch(e){return;}var tiers=(data.tiers||[]).slice().sort(function(a,b){return a.cap-b.cap;});if(!tiers.length)return;var m0=function(v){return '$'+Math.round(v).toLocaleString('en-US');};var k=function(v){return v>=1000?'$'+(Math.round(v/100)/10)+'k':'$'+v;};var pkg=data.packages[data.defaultIndex||0]||data.packages[0];var setup=0;(pkg.lines||[]).forEach(function(l){if(!l.tiered&&!setup)setup=l.price;});var desc=document.querySelector('.hb-svc-title__desc');if(desc&&setup&&!document.querySelector('.bz-hero-price')){var hp=document.createElement('div');hp.className='bz-hero-price';var line=document.createElement('span');line.className='bz-hero-price__line';line.textContent=m0(setup)+' setup, then from '+m0(tiers[0].price)+' a month';hp.appendChild(line);var note=root.querySelector('.hb-order-v2__desc');if(note){var p=document.createElement('p');p.className='bz-hero-price__note';p.textContent=note.textContent.trim();hp.appendChild(p);note.remove();}desc.parentNode.insertBefore(hp,desc.nextSibling);}var bud=root.querySelector('[data-hb-budget]');var range=bud&&bud.querySelector('[data-hb-budget-range]');var scale=bud&&bud.querySelector('.hb-budget__scale');if(!range||!scale||bud.querySelector('.bz-tiers'))return;var step=Number(bud.getAttribute('data-step'))||250;var min=Number(bud.getAttribute('data-min'))||step;var maxCap=tiers[tiers.length-1].cap;var row=document.createElement('div');row.className='bz-tiers';row.setAttribute('role','group');row.setAttribute('aria-label','Management tiers');var cells=[];var prev=0;tiers.forEach(function(t){var mid=Math.max(min,Math.round(((prev+t.cap)/2)/step)*step);prev=t.cap;cells.push({name:t.name,range:m0(t.price)+'/mo',val:mid,test:function(v){return v<=t.cap;}});});cells.push({name:k(maxCap)+'+',range:'Quoted',val:maxCap+step,test:function(v){return v>maxCap;}});var btns=cells.map(function(c){var b=document.createElement('button');b.type='button';b.className='bz-tier';b.innerHTML='<span class="bz-tier__name"></span><span class="bz-tier__range"></span>';b.firstChild.textContent=c.name;b.lastChild.textContent=c.range;b.addEventListener('click',function(){range.value=c.val;range.dispatchEvent(new Event('input',{bubbles:true}));});row.appendChild(b);return b;});scale.parentNode.insertBefore(row,scale.nextSibling);function mark(){var v=Number(range.value)||0;var on=-1;for(var i=0;i<cells.length;i++){if(cells[i].test(v)){on=i;break;}}btns.forEach(function(b,i){b.classList.toggle('is-on',i===on);b.setAttribute('aria-pressed',i===on?'true':'false');});}range.addEventListener('input',mark);mark();}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(go,0);});else setTimeout(go,0);})();
/* BZ 2026-10-20: Google Ads budget slider styled as in the design (four separate pieces, ringed thumb, large amount). Remove this line to undo. */;(function(){if(!document.body.classList.contains('product-google-ads-management'))return;function go(){var bud=document.querySelector('[data-hb-budget]');if(!bud||bud.querySelector('.bz-track'))return;var range=bud.querySelector('[data-hb-budget-range]');if(!range)return;var data;try{data=JSON.parse(document.querySelector('[data-hb-order-data]').textContent);}catch(e){return;}var tiers=(data.tiers||[]).slice().sort(function(a,b){return a.cap-b.cap;});var min=Number(range.min),max=Number(range.max);if(!tiers.length||!(max>min))return;var maxCap=tiers[tiers.length-1].cap;var span=maxCap-min;if(!(span>0))return;var unitStep=span/95;range.step='any';var toIdx=function(b){return b>maxCap?100:Math.max(0,Math.min(95,(b-min)/unitStep));};var toBudget=function(i){if(i>95)return max;return Math.round((min+i*unitStep)/50)*50;};var head=bud.querySelector('.hb-budget__head');var val=bud.querySelector('[data-hb-budget-value]');if(head&&val){head.style.cssText='display:flex;flex-direction:column;align-items:flex-start;gap:6px';var row=document.createElement('span');row.style.cssText='display:flex;align-items:baseline;gap:8px;flex-wrap:wrap';val.parentNode.insertBefore(row,val);row.appendChild(val);val.style.cssText='font-size:32px;font-weight:700;letter-spacing:-.02em;line-height:1.1;color:#fff;font-variant-numeric:tabular-nums';var unit=document.createElement('span');unit.textContent='a month';unit.style.cssText='font-size:15px;color:#C4C4C4';row.appendChild(unit);}var sc=bud.querySelector('.hb-budget__scale');if(sc)sc.style.display='none';var wrap=document.createElement('div');wrap.className='bz-track';wrap.style.cssText='position:relative;height:20px;display:flex;align-items:center;margin:16px 0 6px';var bar=document.createElement('div');bar.style.cssText='position:absolute;left:0;right:0;height:6px;display:flex;gap:3px';var edges=[0];tiers.forEach(function(t){edges.push(toIdx(t.cap));});edges.push(100);var segs=[];for(var i=0;i<edges.length-1;i++){var s=document.createElement('span');s.style.cssText='flex:0 0 auto;width:calc('+(edges[i+1]-edges[i]).toFixed(3)+'% - 2.25px);height:6px;border-radius:3px;background:#323232;transition:background .18s ease-out';bar.appendChild(s);segs.push(s);}var thumb=document.createElement('span');thumb.style.cssText='position:absolute;top:0;width:20px;height:20px;margin-left:-10px;box-sizing:border-box;border-radius:50%;background:#fff;border:4px solid #006EFF;box-shadow:0 0 0 4px rgba(0,110,255,.18);pointer-events:none;transition:box-shadow .12s';var proxy=document.createElement('input');proxy.type='range';proxy.min='0';proxy.max='100';proxy.step='1';proxy.setAttribute('aria-label',range.getAttribute('aria-label')||'Your monthly ad budget');proxy.style.cssText='position:absolute;left:0;right:0;top:-12px;width:100%;height:44px;margin:0;opacity:0;cursor:pointer';wrap.appendChild(bar);wrap.appendChild(thumb);wrap.appendChild(proxy);range.parentNode.insertBefore(wrap,range);range.style.display='none';var busy=false;function paint(){var v=Number(range.value)||min;var idx=toIdx(v);if(!busy)proxy.value=String(Math.round(idx));thumb.style.left='calc(10px + (100% - 20px) * '+(idx/100).toFixed(4)+')';var on=segs.length-1;for(var j=0;j<tiers.length;j++){if(v<=tiers[j].cap){on=j;break;}}segs.forEach(function(g,k){g.style.background=k===on?'#006EFF':'#323232';});}proxy.addEventListener('input',function(){var i=Number(proxy.value);if(i>95&&i<100)i=i>97?100:95;busy=true;range.value=String(toBudget(i));range.dispatchEvent(new Event('input',{bubbles:true}));busy=false;paint();});range.addEventListener('input',function(){if(!busy)paint();});proxy.addEventListener('focus',function(){thumb.style.boxShadow='0 0 0 4px rgba(0,110,255,.45)';});proxy.addEventListener('blur',function(){thumb.style.boxShadow='0 0 0 4px rgba(0,110,255,.18)';});paint();}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(go,50);});else setTimeout(go,50);})();
/* BZ 2026-10-20: Google Ads order box laid out as in the design (budget, tiers, tier box, paid today and then, one button). Google Ads only. Remove this line to undo. */;(function(){if(!document.body.classList.contains('product-google-ads-management'))return;function go(){var root=document.getElementById('hbOrderV2');if(!root||root.querySelector('.bz-ob'))return;var bud=root.querySelector('[data-hb-budget]');var range=bud&&bud.querySelector('[data-hb-budget-range]');var totalEl=root.querySelector('[data-hb-order-total]');var btn=root.querySelector('[data-hb-order-buy]');if(!bud||!range||!totalEl||!btn)return;var data;try{data=JSON.parse(root.querySelector('[data-hb-order-data]').textContent);}catch(e){return;}var tiers=(data.tiers||[]).slice().sort(function(a,b){return a.cap-b.cap;});if(!tiers.length)return;var maxCap=tiers[tiers.length-1].cap;var st=document.createElement('style');st.textContent='body.product-google-ads-management #hbOrderV2 .hb-order-v2__box{gap:18px;padding:22px;background:#0A0A0A;border:1px solid rgba(255,255,255,.12);border-radius:16px}body.product-google-ads-management #hbOrderV2 :is(.hb-order-v2__headline,.hb-order-v2__subline,.hb-order-v2__badge,.hb-order-v2__desc,[data-hb-order-today],[data-hb-order-later],[data-hb-budget-panel],[data-hb-quote],.hb-order-v2__notes,.hb-budget__tier){display:none!important}body.product-google-ads-management #hbOrderV2 .hb-budget{border:0;padding:0;background:none;gap:0;border-radius:0}body.product-google-ads-management #hbOrderV2 .hb-order-v2__btn{height:52px;font-size:15px;font-weight:600;border-radius:10px;background:#006EFF}body.product-google-ads-management #hbOrderV2 .hb-order-v2__btn:hover{background:#3D8EFF}body.product-google-ads-management #hbOrderV2 .hb-order-v2__error:not(:empty){display:block;margin:-6px 0 0;font-size:13px;line-height:1.5}.bz-ob{display:flex;flex-direction:column;gap:18px;margin-top:18px}.bz-ob[hidden],.bz-ob [hidden]{display:none!important}.bz-ob__card{display:flex;gap:10px;align-items:flex-start;font-size:14px;line-height:1.5;font-weight:500;color:#fff}.bz-ob__card svg{flex:0 0 auto;margin-top:2px;color:#C4C4C4}.bz-ob__tier{border:1px solid rgba(0,110,255,.35);background:rgba(0,91,211,.08);border-radius:16px;padding:14px 16px;display:flex;flex-direction:column;gap:4px}.bz-ob__eyebrow{font-size:11px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:#3D8EFF}.bz-ob__line{font-size:16px;font-weight:600;line-height:1.4;color:#fff;font-variant-numeric:tabular-nums}.bz-ob__small{font-size:13px;line-height:1.5;color:#C4C4C4}.bz-ob__low{margin:-6px 0 0;font-size:13px;line-height:1.55;color:#C4C4C4}.bz-ob__more{border:1px solid rgba(255,255,255,.12);border-radius:16px;padding:14px 16px;display:flex;flex-direction:column;gap:4px}.bz-ob__more b{font-size:16px;font-weight:600;line-height:1.4;color:#fff}.bz-ob__more span{font-size:14px;line-height:1.5;color:#C4C4C4}.bz-ob__paid{border-top:1px solid rgba(255,255,255,.12);padding-top:14px;display:flex;flex-direction:column;gap:6px}.bz-ob__row{display:flex;justify-content:space-between;align-items:baseline;gap:12px;color:#fff}.bz-ob__row--big span:first-child{font-size:14px;font-weight:600}.bz-ob__row--big span:last-child{font-size:24px;font-weight:700;letter-spacing:-.01em;font-variant-numeric:tabular-nums}.bz-ob__row--then{font-size:14px}.bz-ob__row--then span:first-child{color:#C4C4C4}.bz-ob__row--then span:last-child{font-weight:600;font-variant-numeric:tabular-nums}';document.head.appendChild(st);var ob=document.createElement('div');ob.className='bz-ob';ob.innerHTML='<div class="bz-ob__card"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="5" width="20" height="14" rx="2"></rect><path d="M2 10h20"></path></svg><span>Paid by your card directly to Google. Never charged by BoldZee.</span></div><div class="bz-ob__tier" data-bz-ob-tier><span class="bz-ob__eyebrow">Your management tier</span><span class="bz-ob__line" data-bz-ob-line></span><span class="bz-ob__small">Set by your budget, not chosen separately. If your spend moves to another band, the tier changes at the next billing date, only with your approval.</span></div><p class="bz-ob__low" data-bz-ob-low hidden>Below about $1,000 a month, most markets give campaigns too little data to learn from. We will still run them, and we will tell you plainly if the budget is holding results back.</p><div class="bz-ob__more" data-bz-ob-more hidden><b data-bz-ob-more-title></b><span>Email us and we will quote within one business day.</span></div><div class="bz-ob__paid" data-bz-ob-paid><div class="bz-ob__row bz-ob__row--big"><span>Paid today</span><span data-bz-ob-today></span></div><div class="bz-ob__row bz-ob__row--then"><span>Then</span><span data-bz-ob-then></span></div><span class="bz-ob__small">First three months, then month to month. Your ad budget is not in either figure.</span></div>';bud.appendChild(ob);btn.setAttribute('data-quote-text','Email us for a quote');var q=function(s){return ob.querySelector(s);};var m0=function(v){return '$'+Math.round(v).toLocaleString('en-US');};var band=function(i){var lo=i===0?0:tiers[i-1].cap;return lo?'ad spend '+m0(lo)+' to '+m0(tiers[i].cap):'ad spend up to '+m0(tiers[i].cap);};function update(){var v=Number(range.value)||0;var more=v>maxCap;var ti=tiers.length-1;for(var i=0;i<tiers.length;i++){if(v<=tiers[i].cap){ti=i;break;}}var t=tiers[ti];q('[data-bz-ob-tier]').hidden=more;q('[data-bz-ob-paid]').hidden=more;q('[data-bz-ob-more]').hidden=!more;q('[data-bz-ob-more-title]').textContent='Above '+m0(maxCap)+' a month';q('[data-bz-ob-low]').hidden=more||v>=1000;q('[data-bz-ob-line]').textContent=t.name+' · '+m0(t.price)+' a month · '+band(ti);q('[data-bz-ob-today]').textContent=(totalEl.textContent||'').trim().replace(/\.00$/,'');q('[data-bz-ob-then]').textContent=m0(t.price)+' a month';}var tm;var later=function(){clearTimeout(tm);tm=setTimeout(update,20);};new MutationObserver(later).observe(totalEl,{childList:true,characterData:true,subtree:true});range.addEventListener('input',later);root.addEventListener('click',later);document.addEventListener('change',later);update();}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(go,80);});else setTimeout(go,80);})();
/* BZ 2026-10-20: Google Ads order summary beside the add-ons, team and intake, as in the design; the top box no longer sticks. Google Ads only. Remove this line to undo. */;(function(){if(!document.body.classList.contains('product-google-ads-management'))return;function go(){var root=document.getElementById('hbOrderV2');if(!root||document.getElementById('bzOS'))return;var side=root.parentElement;var lay=side&&side.parentElement;var range=root.querySelector('[data-hb-budget-range]');var totalEl=root.querySelector('[data-hb-order-total]');var lines=root.querySelector('[data-hb-order-lines]');var btn=root.querySelector('[data-hb-order-buy]');if(!lay||!range||!totalEl||!lines||!btn)return;var data;try{data=JSON.parse(root.querySelector('[data-hb-order-data]').textContent);}catch(e){return;}var tiers=(data.tiers||[]).slice().sort(function(a,b){return a.cap-b.cap;});if(!tiers.length)return;var maxCap=tiers[tiers.length-1].cap;var P='body.product-google-ads-management ';var st=document.createElement('style');st.textContent='@media screen and (min-width:990px){'+P+'.hb-service-layout__sidebar{position:static!important;max-height:none!important;overflow:visible!important;align-self:stretch!important;top:auto!important}'+P+'#bzOS{position:sticky}}#bzOS{display:flex;flex-direction:column;gap:16px;margin:24px 0 0;border:1px solid rgba(255,255,255,.12);border-radius:16px;background:#0A0A0A;padding:22px;color:#fff;box-sizing:border-box}#bzOS[hidden],#bzOS [hidden]{display:none!important}#bzOS h2{margin:0;font-size:18px;font-weight:700;letter-spacing:-.01em;line-height:1.3;color:#fff;text-transform:none}#bzOS .os-g{display:flex;flex-direction:column;gap:9px;border-top:1px solid rgba(255,255,255,.12);padding-top:14px}#bzOS .os-e{font-size:11px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:#3D8EFF}#bzOS .os-r{display:flex;justify-content:space-between;gap:14px;font-size:14px;line-height:1.45}#bzOS .os-r span:last-child{font-variant-numeric:tabular-nums;white-space:nowrap;text-align:right}#bzOS .os-t{display:flex;flex-direction:column;gap:3px;border-top:1px solid rgba(255,255,255,.12);padding-top:11px;margin-top:3px}#bzOS .os-t .os-r{align-items:baseline}#bzOS .os-t b{font-size:14px;font-weight:600}#bzOS .os-t strong{font-size:24px;font-weight:700;letter-spacing:-.01em;font-variant-numeric:tabular-nums}#bzOS .os-then{font-size:13px;color:#C4C4C4}#bzOS .os-then span:last-child{font-weight:600;color:#fff}#bzOS .os-term{display:flex;flex-direction:column;gap:2px;font-size:13px;line-height:1.5}#bzOS .os-term span:first-child{color:#C4C4C4}#bzOS .os-g2{border:1px dashed #6E6E6E;border-radius:10px;background:rgba(255,255,255,.03);padding:14px;display:flex;flex-direction:column;gap:9px}#bzOS .os-g2 .os-h{display:flex;gap:8px;align-items:center;font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:#C4C4C4}#bzOS .os-g2 .os-r{color:#C4C4C4}#bzOS .os-g2 small{font-size:12px;line-height:1.5;color:#C4C4C4}#bzOS .os-btn{all:unset;box-sizing:border-box;cursor:pointer;width:100%;height:52px;display:flex;align-items:center;justify-content:center;border-radius:10px;background:#006EFF;color:#fff;font-size:15px;font-weight:600}#bzOS .os-btn:hover{background:#3D8EFF}#bzOS .os-btn:focus-visible{outline:2px solid #3D8EFF;outline-offset:2px}#bzOS .os-note{margin:0;font-size:13px;line-height:1.6;color:#C4C4C4}';document.head.appendChild(st);var os=document.createElement('aside');os.id='bzOS';os.className='bz-tiers';os.setAttribute('aria-label','Order summary');os.innerHTML='<h2>Order summary</h2><div class="os-g"><span class="os-e">Paid to BoldZee today</span><div class="os-r"><span>Campaign setup</span><span data-os-setup></span></div><div class="os-r"><span data-os-fmn></span><span data-os-fmv></span></div><div data-os-adds style="display:flex;flex-direction:column;gap:9px"></div><div class="os-t" data-os-tot><div class="os-r"><b>Paid today</b><strong data-os-today></strong></div><div class="os-r os-then"><span>Then</span><span data-os-then></span></div></div></div><div class="os-g"><span class="os-e">Paid to BoldZee monthly</span><div class="os-r"><span data-os-mn></span><span data-os-mv></span></div><div class="os-term"><span>Term</span><span>Months 2 and 3 included in your first term, then month to month</span></div></div><div class="os-g2"><span class="os-h"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="5" width="20" height="14" rx="2"></rect><path d="M2 10h20"></path></svg>Paid to Google, not to us</span><div class="os-r"><span>Your ad budget</span><span data-os-bud></span></div><div class="os-r"><span>How it is paid</span><span style="white-space:normal">Your own card, billed by Google</span></div><small>For your information only. Not part of any BoldZee total.</small></div><button type="button" class="os-btn" data-os-btn></button><p class="os-note">Your specialist is assigned the same day and starts building as soon as you check out. Campaigns go live within 10 business days of a completed intake and an active payment method in your Google Ads account. If they do not, your first month of management is free.</p>';side.appendChild(os);var q=function(s){return os.querySelector(s);};var m0=function(v){return '$'+Math.round(v).toLocaleString('en-US');};var clean=function(s){s=(s||'').trim().split(String.fromCharCode(10)).join(' ').replace(/ {2,}/g,' ');return s.replace(/[.]00(?=[^0-9]*$)/,'');};q('[data-os-btn]').addEventListener('click',function(){btn.click();});function update(){var v=Number(range.value)||0;var more=v>maxCap;var ti=tiers.length-1;for(var i=0;i<tiers.length;i++){if(v<=tiers[i].cap){ti=i;break;}}var t=tiers[ti];var ls=[].slice.call(lines.children).map(function(r){var c=r.children;return [clean(c[0]&&c[0].textContent),clean(c[c.length-1]&&c[c.length-1].textContent)];});q('[data-os-setup]').textContent=ls[0]?ls[0][1]:'';q('[data-os-fmn]').textContent=more?'First month of management':'First month, '+t.name;q('[data-os-fmv]').textContent=more?'Quoted by email':m0(t.price);var ad=q('[data-os-adds]');ad.innerHTML='';ls.slice(2).forEach(function(x){var r=document.createElement('div');r.className='os-r';var a=document.createElement('span');a.textContent=x[0];var b=document.createElement('span');b.textContent=x[1];r.appendChild(a);r.appendChild(b);ad.appendChild(r);});ad.hidden=ls.length<3;q('[data-os-tot]').hidden=more;q('[data-os-today]').textContent=clean(totalEl.textContent);q('[data-os-then]').textContent=m0(t.price)+' a month';q('[data-os-mn]').textContent=more?'Management, custom tier':'Management, '+t.name;q('[data-os-mv]').textContent=more?'Quoted within one business day':m0(t.price)+' a month';q('[data-os-bud]').textContent=more?'More than '+m0(maxCap)+' a month':m0(v)+' a month';q('[data-os-btn]').textContent=clean(btn.textContent)||'Add to cart';place();}function place(){var wide=window.innerWidth>=990&&getComputedStyle(lay).gridTemplateColumns.split(' ').length>1;var anc=document.querySelector('.hb-addons-head')||document.querySelector('.hb-team-section');if(!wide||!anc){os.style.marginTop='';os.style.top='';return;}var gap=anc.getBoundingClientRect().top-root.getBoundingClientRect().bottom;os.style.marginTop=Math.max(24,Math.round(gap))+'px';os.style.top=Math.min(80,window.innerHeight-os.offsetHeight-16)+'px';}var tm;var later=function(){clearTimeout(tm);tm=setTimeout(update,30);};new MutationObserver(later).observe(root,{childList:true,characterData:true,subtree:true});range.addEventListener('input',later);document.addEventListener('click',later);document.addEventListener('change',later);window.addEventListener('resize',later);window.addEventListener('load',later);if(window.ResizeObserver){var main=lay.firstElementChild;if(main&&main!==side)new ResizeObserver(later).observe(main);}update();}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(go,120);});else setTimeout(go,120);})();
/* BZ 2026-10-22: LPD and Local SEO add-on slider arrows; Conversion Tracking two columns, walkthrough dot, button needs a module; Store Setup extra products not preselected. Only these products. Remove this line to undo. */;(function(){var B=document.body.classList;var lpd=true;/* BZ 2026-10-22: arrows on every product whose add-ons row scrolls */var ct=B.contains('product-conversion-tracking-setup');var css=B.contains('product-complete-shopify-store-setup');if(!lpd&&!ct&&!css)return;function slider(){document.querySelectorAll('.hb-addons-row').forEach(function(row){if(row.getAttribute('data-bz-nav'))return;if(row.children.length<2)return;row.setAttribute('data-bz-nav','1');var nav=document.createElement('div');nav.className='bz-ar-nav';nav.innerHTML='<button type="button" class="bz-ar-btn" data-d="-1" aria-label="Previous"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"></path></svg></button><button type="button" class="bz-ar-btn" data-d="1" aria-label="Next"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"></path></svg></button>';var hd=row.previousElementSibling;if(hd&&hd.classList.contains('hb-addons-head')){hd.classList.add('bz-ar-has');hd.appendChild(nav);}else row.parentNode.insertBefore(nav,row);var bs=nav.querySelectorAll('button');function step(){var k=row.children[0];var g=parseFloat(getComputedStyle(row).columnGap)||20;return k?k.getBoundingClientRect().width+g:row.clientWidth;}function upd(){var max=row.scrollWidth-row.clientWidth-2;bs[0].disabled=row.scrollLeft<=2;bs[1].disabled=row.scrollLeft>=max;nav.hidden=max<=0;}bs.forEach(function(b){b.addEventListener('click',function(){row.scrollBy({left:step()*Number(b.getAttribute('data-d')),behavior:'smooth'});});});row.addEventListener('scroll',function(){clearTimeout(row.__t);row.__t=setTimeout(upd,60);},{passive:true});window.addEventListener('resize',upd);upd();});}function ctLayout(){var main=document.querySelector('.hb-service-layout__main');var ban=document.querySelector('.hb-product-banner');if(!main||!ban||main.contains(ban))return;var sec=ban.closest('.shopify-section');main.insertBefore(ban,main.firstChild);ban.classList.add('bz-ct-banner');if(sec)sec.style.display='none';}function ctDot(){var it=[].slice.call(document.querySelectorAll('.hb-receive-list__item')).filter(function(i){return /Tracking Walkthrough/i.test(i.textContent);})[0];var cb=document.querySelector('input[data-product-handle="initial-report-video-walkthrough"]');if(!it||!cb)return;function upd(){it.classList.toggle('bz-off',!cb.checked);}document.addEventListener('change',function(){setTimeout(upd,0);});document.addEventListener('click',function(){setTimeout(upd,30);});upd();}function ctBtn(){var btn=document.querySelector('.hb-bundle__order-summary .hb-bundle__buy-now');if(!btn)return;var svc=function(){return [].some.call(document.querySelectorAll('.hb-bundle__item--service .hb-bundle__checkbox'),function(c){return c.checked;});};function fix(){if(!svc()&&!btn.disabled)btn.disabled=true;}new MutationObserver(fix).observe(btn,{attributes:true,attributeFilter:['disabled']});document.addEventListener('change',function(){setTimeout(fix,0);});document.addEventListener('click',function(){setTimeout(fix,30);});btn.addEventListener('click',function(e){if(!svc()){e.preventDefault();e.stopImmediatePropagation();}},true);fix();}function apu(){var cb=document.querySelector('input[data-product-handle="additional-product-uploads"]');if(!cb||cb.getAttribute('data-bz-init'))return;cb.setAttribute('data-bz-init','1');if(cb.checked)cb.click();}function go(){if(lpd)slider();if(ct){ctLayout();ctDot();ctBtn();}if(css)apu();}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(go,300);});else setTimeout(go,300);})();
/* BZ 2026-10-22: Product Page Optimization laid out as in the design (what we optimize and the team side by side below the intake, add-on texts, sample notes). This product only. Remove this line to undo. */;(function(){if(!document.body.classList.contains('product-shopify-product-optimization'))return;var D={'product-copy-enhancement':'The base service rewrites what a shopper reads first: title, key benefits and the lines around the button. This goes the whole way: the full description, specifications rewritten for a buyer rather than a warehouse, an on-page FAQ, and search titles and descriptions. For products where the words have to do most of the selling.','product-image-optimization':'The base service chooses and reorders your existing images. This improves them: retouched, consistently sized and compressed so the page stays fast, with a clear plan for any shot you are missing, such as scale, in use or detail. For products where the photos are holding the page back.'};function go(){Object.keys(D).forEach(function(h){var cb=document.querySelector('.hb-bundle__item--addon input[data-product-handle="'+h+'"]');var it=cb&&cb.closest('.hb-bundle__item');var d=it&&it.querySelector('.hb-bundle__desc');if(d)d.innerHTML='<p>'+D[h]+'</p>';});document.querySelectorAll('.hb-sample-note p').forEach(function(p){var t=p.textContent;var i=t.indexOf(' Removes: ');if(i>0&&!p.querySelector('strong')){p.innerHTML='';var s=document.createElement('strong');s.textContent=t.slice(0,i);var r=document.createElement('span');r.textContent=t.slice(i+1);p.appendChild(s);p.appendChild(r);}});var an=document.querySelector('.hb-analyze-section');var tm=document.querySelector('.hb-team-section');var side=document.querySelector('.hb-service-layout__sidebar');var lay=side&&side.parentElement;if(!an||!tm||!lay||document.querySelector('.bz-ppo-band'))return;var band=document.createElement('div');band.className='bz-ppo-band';band.appendChild(an);lay.parentNode.insertBefore(band,lay.nextSibling);}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(go,200);});else setTimeout(go,200);})();
/* BZ 2026-10-22: add-on "View Samples" for an interactive sample page (custom.sample_html, a .txt file): opens it, working, in the report popup. Remove this line to undo. */;(function(){document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('.bz-html-sample');if(!a)return;e.preventDefault();e.stopPropagation();var open=function(u){var t=document.createElement('a');t.href='#';t.className='hb-open-html-report';t.setAttribute('data-title',a.getAttribute('data-title')||'Sample');t.setAttribute('data-url',u);t.style.display='none';document.body.appendChild(t);t.click();t.remove();};if(a.__bzUrl){open(a.__bzUrl);return;}
var f=a.getAttribute('data-html-file');if(f&&f.indexOf('/pages/')>-1)a.__bzPage=true;if(!f||a.__bzBusy)return;
a.__bzBusy=true;var lab=a.querySelector('.hb-open-pdf__text');var old=lab?lab.textContent:'';if(lab)lab.textContent='Opening...';fetch(f).then(function(r){if(!r.ok)throw new Error('load');return r.text();}).then(function(t){var d=t.trim();if(a.__bzPage)d=d.split('"//').join('"https://');if(d.charAt(0)!=='<'){var s=atob(d.split(String.fromCharCode(10)).join('').split(String.fromCharCode(13)).join(''));var u8=new Uint8Array(s.length);for(var i=0;i<s.length;i++)u8[i]=s.charCodeAt(i);d=u8;var tx=new TextDecoder().decode(u8);if(tx.indexOf('@@CORE@@')>-1)d=tx.split('@@CORE@@').join(a.getAttribute('data-core')||'').replace(/<head[^>]*>/i,function(m){return m+'<script>window.__resources={};</'+'script>';});}a.__bzUrl=URL.createObjectURL(new Blob([d],{type:'text/html;charset=utf-8'}));open(a.__bzUrl);}).catch(function(){}).then(function(){a.__bzBusy=false;if(lab)lab.textContent=old;});},true);})();